import React, { useState, useCallback, useMemo, useContext, useEffect } from 'react';
import { ReactSVG } from 'react-svg';
import classNames from 'classnames';
import { Form, Button } from 'react-bootstrap';
import { createPortal } from 'react-dom';
import { v4 } from 'uuid';
import i18next from 'i18next';
import { useHistory } from 'react-router-dom';
import Cookies from 'js-cookie';
import * as Sentry from '@sentry/browser';
import QueryString from 'query-string';

function Icon(param) {
    var className = param.className, src = param.src, width = param.width, height = param.height, fill = param.fill, stroke = param.stroke;
    return /*#__PURE__*/ React.createElement(ReactSVG, {
        className: className,
        src: src,
        afterInjection: function(error, svg) {
            if (error) {
                console.error(error);
                return;
            }
            var paths = svg.querySelectorAll('path');
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = paths[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var path = _step.value;
                    if (fill) {
                        path.setAttribute('fill', fill);
                    }
                    if (stroke) {
                        path.setAttribute('stroke', stroke);
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        },
        beforeInjection: function(svg) {
            if (width) {
                svg.setAttribute('style', "width: ".concat(width, "px"));
            }
            if (height) {
                svg.setAttribute('style', "height: ".concat(height, "px"));
            }
        }
    });
}

var e=[],t=[];function n(n,r){if(n&&"undefined"!=typeof document){var a,s=!0===r.prepend?"prepend":"append",d=!0===r.singleTag,i="string"==typeof r.container?document.querySelector(r.container):document.getElementsByTagName("head")[0];if(d){var u=e.indexOf(i);-1===u&&(u=e.push(i)-1,t[u]={}),a=t[u]&&t[u][s]?t[u][s]:t[u][s]=c();}else a=c();65279===n.charCodeAt(0)&&(n=n.substring(1)),a.styleSheet?a.styleSheet.cssText+=n:a.appendChild(document.createTextNode(n));}function c(){var e=document.createElement("style");if(e.setAttribute("type","text/css"),r.attributes)for(var t=Object.keys(r.attributes),n=0;n<t.length;n++)e.setAttribute(t[n],r.attributes[t[n]]);var a="prepend"===s?"afterbegin":"beforeend";return i.insertAdjacentElement(a,e),e}}

var css$1 = ".CheckBox_module_checkBoxGroup__fb8d6125 {\n  display: flex !important;\n  align-items: center !important;\n  gap: 8px;\n  width: 100%;\n}\n.CheckBox_module_checkBoxGroup__fb8d6125 label {\n  flex-grow: 1;\n  margin: 0 !important;\n  margin-right: 16px;\n  margin-bottom: 0 !important;\n  font-weight: bold;\n  font-size: 14px;\n  line-height: 20px;\n  color: rgba(15, 15, 31, 0.7);\n}\n.CheckBox_module_checkBoxGroup__fb8d6125 label .CheckBox_module_requiredMark__fb8d6125 {\n  color: #f5222d;\n}\n\n.CheckBox_module_checkbox__fb8d6125 input {\n  cursor: pointer;\n  width: 24px !important;\n  height: 24px !important;\n  border: 1px solid #e5e6e7;\n  box-sizing: border-box;\n  border-radius: 8px;\n}\n.CheckBox_module_checkbox__fb8d6125 input.CheckBox_module_isInvalid__fb8d6125 {\n  background-image: none;\n  padding-right: 0.75rem;\n}\n.CheckBox_module_checkbox__fb8d6125 input.CheckBox_module_isInvalid__fb8d6125 + .CheckBox_module_inputGroupText__fb8d6125 {\n  border-color: #dc3545;\n}\n.CheckBox_module_checkbox__fb8d6125 input:active,\n.CheckBox_module_checkbox__fb8d6125 input:focus {\n  outline: none !important;\n  box-shadow: none !important;\n  border: 1px solid #e5e6e7;\n}";
var modules_9f91d0e8 = {"checkBoxGroup":"CheckBox_module_checkBoxGroup__fb8d6125","required-mark":"CheckBox_module_requiredMark__fb8d6125","checkbox":"CheckBox_module_checkbox__fb8d6125","is-invalid":"CheckBox_module_isInvalid__fb8d6125","input-group-text":"CheckBox_module_inputGroupText__fb8d6125"};
n(css$1,{});

function CheckBox(param) {
    var title = param.title, checked = param.checked, onChange = param.onChange;
    return /*#__PURE__*/ React.createElement(Form.Group, {
        className: classNames(modules_9f91d0e8.checkBoxGroup)
    }, /*#__PURE__*/ React.createElement(Form.Label, null, /*#__PURE__*/ React.createElement("span", null, title)), /*#__PURE__*/ React.createElement(Form.Check, {
        className: modules_9f91d0e8.checkbox,
        checked: checked,
        onChange: function() {
            onChange(!checked);
        }
    }));
}

var css = ".Toast_module_toastContainer__7ea19929 {\n  position: fixed;\n  left: 50%;\n  top: 24px;\n  transform: translate(-50%, 0);\n  width: auto !important;\n  z-index: 2;\n}\n.Toast_module_toastContainer__7ea19929 .Toast_module_toastMessage__7ea19929 {\n  border-radius: 4px;\n  padding: 8px 12px;\n  font-size: 14px;\n  line-height: 20px;\n  text-align: center;\n  animation: Toast_module_fadein__7ea19929 0.5s;\n}\n.Toast_module_toastContainer__7ea19929 .Toast_module_toastMessage__7ea19929.Toast_module_error__7ea19929 {\n  background-color: #f5222d;\n  color: white;\n}\n.Toast_module_toastContainer__7ea19929 .Toast_module_toastMessage__7ea19929.Toast_module_success__7ea19929 {\n  background-color: #23B16D;\n  color: white;\n}\n\n@keyframes Toast_module_fadein__7ea19929 {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}";
var modules_ae1273d6 = {"toastContainer":"Toast_module_toastContainer__7ea19929","toastMessage":"Toast_module_toastMessage__7ea19929","fadein":"Toast_module_fadein__7ea19929","error":"Toast_module_error__7ea19929","success":"Toast_module_success__7ea19929"};
n(css,{});

function _array_like_to_array$1(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes$1(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array$1(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit$1(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest$1() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array$1(arr, i) {
    return _array_with_holes$1(arr) || _iterable_to_array_limit$1(arr, i) || _unsupported_iterable_to_array$1(arr, i) || _non_iterable_rest$1();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array$1(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array$1(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array$1(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array$1(o, minLen);
}
var ToastContext = /*#__PURE__*/ React.createContext({});
var TIMEOUT = 5 * 1000;
function ToastContextProvider(param) {
    var children = param.children, id = param.id;
    var _useState = _sliced_to_array$1(useState([]), 2), messages = _useState[0], setMessages = _useState[1];
    var toast = useCallback(function(message, type) {
        var id = v4();
        setMessages(function(messages) {
            return [
                {
                    id: id,
                    type: type,
                    message: message
                }
            ].concat(_to_consumable_array(messages));
        });
        setTimeout(function() {
            setMessages(function(messages) {
                return messages.filter(function(message) {
                    return message.id !== id;
                });
            });
        }, TIMEOUT);
    }, []);
    var toastError = useCallback(function(error) {
        var _error_data, _error_data1;
        if ((_error_data = error.data) === null || _error_data === void 0 ? void 0 : _error_data.errorCode) {
            var message = i18next.t("apiError.".concat(error.data.errorCode));
            if (message) {
                toast(message, 'error');
                return;
            }
        }
        toast(((_error_data1 = error.data) === null || _error_data1 === void 0 ? void 0 : _error_data1.message) || error.message || error || 'Something went wrong', 'error');
    }, [
        toast
    ]);
    var toastSuccess = useCallback(function(message) {
        toast(message, 'success');
    }, [
        toast
    ]);
    var contextValue = useMemo(function() {
        return {
            messages: messages,
            toastError: toastError,
            toastSuccess: toastSuccess,
            setMessages: setMessages,
            id: id
        };
    }, [
        messages,
        toastError,
        toastSuccess,
        setMessages,
        id
    ]);
    var el = document.getElementById(id);
    if (!el) {
        var el1 = document.createElement('DIV');
        el1.id = id;
        document.body.appendChild(el1);
    }
    return /*#__PURE__*/ React.createElement(ToastContext.Provider, {
        value: contextValue
    }, children);
}
function useToastContext() {
    return useContext(ToastContext);
}
function Toast(param) {
    var fixed = param.fixed;
    var _useToastContext = useToastContext(), messages = _useToastContext.messages, setMessages = _useToastContext.setMessages, id = _useToastContext.id;
    return /*#__PURE__*/ createPortal(/*#__PURE__*/ React.createElement("div", {
        className: modules_ae1273d6.toastContainer,
        style: {
            position: fixed ? 'fixed' : undefined,
            zIndex: 2000
        }
    }, messages.map(function(message) {
        return /*#__PURE__*/ React.createElement("div", {
            key: message.id,
            className: "".concat(modules_ae1273d6.toastMessage, " ").concat(modules_ae1273d6[message.type]),
            onClick: function() {
                setMessages(function(messages) {
                    return messages.filter(function(m) {
                        return message.id !== m.id;
                    });
                });
            },
            style: {
                pointerEvents: 'all'
            }
        }, message.message);
    })), document.getElementById(id));
}

function _define_property$3(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var Key = {
    ENTER: 13,
    TAB: 9,
    DOLLAR: 52,
    UP: 38,
    DOWN: 40
};
var KeyCharacter = {
    DOLLAR: '$',
    ENTER: 'Enter',
    TAB: 'Tab',
    ARROW_UP: 'ArrowUp',
    ARROW_DOWN: 'ArrowDown',
    ESCAPE: 'Escape'
};
var ImageType = {
    NORMAL: 'normal',
    PANO: 'pano',
    FLOOR_PLAN: 'floorplan'
};
var LightItensity = {
    STRONG: 'strong',
    SOFT: 'soft'
};
var LightColor = {
    WARM: 'warm',
    WHITE: 'white'
};
var Mode = {
    NORMAL: 'normal',
    EMBED: 'embed'
};
var _obj;
var ImageTypeNameMap = (_obj = {}, _define_property$3(_obj, ImageType.NORMAL, '2D'), _define_property$3(_obj, ImageType.PANO, '360°'), _define_property$3(_obj, ImageType.FLOOR_PLAN, 'Floor plan'), _obj);
var FloorPlanStatus = {
    UPLOADING: 'uploading',
    NEEDS_INFORMATION: 'needs_information',
    CREATED: 'created',
    READY: 'ready',
    REFUNDED: 'refunded',
    FAILED: 'failed',
    EXTRA_COST_APPROVAL: 'extra_cost_approval',
    REQUEST_REFUND: 'request_refund',
    REQUEST_FILES: 'request_files',
    CHANGE_REQUESTED: 'change_requested',
    CONVERTING: 'converting'
};
var FloorPlanFileSource = {
    USER_UPLOAD: 'user_upload',
    CAD: 'cad',
    VIDEO: 'video'
};
var _obj1;
var FloorPlanFileSourceName = (_obj1 = {}, _define_property$3(_obj1, FloorPlanFileSource.USER_UPLOAD, 'User uploads'), _define_property$3(_obj1, FloorPlanFileSource.VIDEO, 'Video'), _define_property$3(_obj1, FloorPlanFileSource.CAD, 'CAD'), _obj1);
var FloorPlanLogName = {
    DESIGNER_CLAIM: 'designer_claim',
    DESIGNER_UPLOAD_FRAME_FILE: 'designer_upload_frame_file',
    DESIGNER_UPLOAD_PROJECT_FILE: 'designer_upload_project_file',
    DESIGNER_UPLOAD_2D_BACKGROUND_FILE: 'designer_upload_2d_background_file',
    DESIGNER_UPLOAD_2D_OVERVIEW_FILE: 'designer_upload_2d_overview_file',
    DESIGNER_RENDER_3D_OVERVIEW: 'designer_render_3d_overview',
    DESIGNER_RENDER_3D_OVERVIEW_DONE: 'designer_render_3d_overview_done',
    DESIGNER_RENDER_3D_OVERVIEW_ERROR: 'designer_render_3d_overview_error',
    DESIGNER_SUBMIT: 'designer_submit',
    DESIGNER_REPORT: 'designer_report',
    USER_SUBMIT_CHANGE_REQUEST: 'user_submit_change_request',
    ADMIN_CHARGE: 'admin_charge',
    USER_REQUEST_VIDEO: 'user_request_video',
    USER_REQUEST_CAD: 'user_request_cad'
};
var FloorPlanPackage = {
    STANDARD_2D: 'standard_2d',
    STANDARD_2D_WITH_SITE_PLAN: 'standard_2d_with_site_plan',
    COLOR_2D: 'color_2d',
    COLOR_2D_WITH_SITE_PLAN: 'color_2d_with_site_plan',
    STANDARD_3D: 'standard_3d',
    INSERT_FURNITURE_2D: 'insert_furniture_2d',
    INSERT_CAMERAS_AND_FURNITURE_3D: 'insert_cameras_and_furniture_3d',
    VIDEO: 'video',
    CAD: 'cad',
    TOUR: 'tour',
    MATTERPORT: 'matterport',
    P_2D_8_12_H: '2d_8_12_h',
    P_3D_16_18_H: '3d_16_18_h',
    ROOM_PLAN: 'room_plan',
    REDRAW_ROOM_PLAN: 'redraw_room_plan'
};
var _obj2;
var FloorPlanPackageName = (_obj2 = {}, _define_property$3(_obj2, FloorPlanPackage.STANDARD_2D, 'Standard 2D'), _define_property$3(_obj2, FloorPlanPackage.STANDARD_2D_WITH_SITE_PLAN, 'Standard 2D with site plan'), _define_property$3(_obj2, FloorPlanPackage.COLOR_2D, 'Colorful 2D'), _define_property$3(_obj2, FloorPlanPackage.COLOR_2D_WITH_SITE_PLAN, 'Colorful 2D with site plan'), _define_property$3(_obj2, FloorPlanPackage.STANDARD_3D, 'Standard 3D'), _define_property$3(_obj2, FloorPlanPackage.VIDEO, 'Video'), _define_property$3(_obj2, FloorPlanPackage.CAD, 'CAD'), _define_property$3(_obj2, FloorPlanPackage.INSERT_FURNITURE_2D, 'Insert furniture'), _define_property$3(_obj2, FloorPlanPackage.INSERT_CAMERAS_AND_FURNITURE_3D, 'Insert furniture and camera'), _define_property$3(_obj2, FloorPlanPackage.MATTERPORT, 'Matterport'), _define_property$3(_obj2, FloorPlanPackage.P_2D_8_12_H, 'Complete in 8-12 hours'), _define_property$3(_obj2, FloorPlanPackage.P_3D_16_18_H, 'Compete in 16-18 hours'), _define_property$3(_obj2, FloorPlanPackage.ROOM_PLAN, 'Room plan'), _define_property$3(_obj2, FloorPlanPackage.REDRAW_ROOM_PLAN, 'Re-draw room plan'), _obj2);
var PerFloorPackages = [
    FloorPlanPackage.STANDARD_2D,
    FloorPlanPackage.STANDARD_2D_WITH_SITE_PLAN,
    FloorPlanPackage.COLOR_2D,
    FloorPlanPackage.COLOR_2D_WITH_SITE_PLAN,
    FloorPlanPackage.STANDARD_3D,
    FloorPlanPackage.INSERT_FURNITURE_2D,
    FloorPlanPackage.INSERT_CAMERAS_AND_FURNITURE_3D,
    FloorPlanPackage.MATTERPORT,
    FloorPlanPackage.P_2D_8_12_H,
    FloorPlanPackage.P_3D_16_18_H,
    FloorPlanPackage.ROOM_PLAN,
    FloorPlanPackage.REDRAW_ROOM_PLAN
];

var AUTO_STAGING_PREFERENCES_SPECS = [
    {
        name: 'modal.autoStagingSelectBundles.curtains',
        key: 'curtains',
        options: [
            {
                value: false,
                label: 'modal.autoStagingSelectBundles.dontUse'
            },
            {
                value: true,
                label: 'modal.autoStagingSelectBundles.use'
            }
        ],
        default: false
    },
    {
        name: 'modal.autoStagingSelectBundles.tabletops',
        key: 'tabletops',
        options: [
            {
                value: 'decorative',
                label: 'modal.autoStagingSelectBundles.decorative'
            },
            {
                value: 'clean',
                label: 'modal.autoStagingSelectBundles.none'
            }
        ],
        default: 'decorative'
    },
    {
        name: 'modal.autoStagingSelectBundles.plants',
        key: 'plants',
        options: [
            {
                value: 'none',
                label: 'modal.autoStagingSelectBundles.none'
            },
            {
                value: 'few',
                label: 'modal.autoStagingSelectBundles.few'
            },
            {
                value: 'plenty',
                label: 'modal.autoStagingSelectBundles.plenty'
            }
        ],
        default: 'none'
    },
    {
        name: 'modal.autoStagingSelectBundles.tvBedroom',
        key: 'tvBedroom',
        options: [
            {
                value: 'always',
                label: 'modal.autoStagingSelectBundles.always'
            },
            {
                value: 'when_in_bundle',
                label: 'modal.autoStagingSelectBundles.whenInBundle'
            },
            {
                value: 'never',
                label: 'modal.autoStagingSelectBundles.never'
            }
        ],
        default: 'when_in_bundle'
    },
    {
        name: 'modal.autoStagingSelectBundles.tvLivingRoom',
        key: 'tvLivingRoom',
        options: [
            {
                value: 'always',
                label: 'modal.autoStagingSelectBundles.always'
            },
            {
                value: 'when_in_bundle',
                label: 'modal.autoStagingSelectBundles.whenInBundle'
            },
            {
                value: 'never',
                label: 'modal.autoStagingSelectBundles.never'
            }
        ],
        default: 'when_in_bundle'
    },
    {
        name: 'modal.autoStagingSelectBundles.lampLights',
        key: 'lampLights',
        options: [
            {
                value: false,
                label: 'modal.autoStagingSelectBundles.off'
            },
            {
                value: true,
                label: 'modal.autoStagingSelectBundles.on'
            }
        ],
        default: false
    }
];
var AUTO_STAGING_DEFAULT_PREFERENCES = function() {
    var res = {};
    AUTO_STAGING_PREFERENCES_SPECS.forEach(function(spec) {
        res[spec.key] = spec.default;
    });
    return res;
}();

var img = "data:image/svg+xml,%3csvg width='200' height='220' viewBox='0 0 200 220' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cg clip-path='url(%23clip0_104_14723)'%3e%3cpath d='M64.8942 75.9502L38.6219 181.288C37.5149 185.718 37.8469 190.383 39.5702 194.614C41.2935 198.844 44.3194 202.423 48.2138 204.836C58.2355 211.038 74.8037 217.751 100.14 218.521C126.996 219.337 144.861 211.659 155.426 204.691C159.159 202.226 162.035 198.671 163.658 194.516C165.281 190.36 165.572 185.806 164.491 181.479L138.17 75.9502' fill='%230F0F1F' fill-opacity='0.07'/%3e%3cpath d='M101.532 80.8421C136.364 80.8421 164.602 71.3663 164.602 59.6772C164.602 47.9881 136.364 38.5122 101.532 38.5122C66.6986 38.5122 38.4609 47.9881 38.4609 59.6772C38.4609 71.3663 66.6986 80.8421 101.532 80.8421Z' fill='%23212529'/%3e%3cpath d='M101.531 81.194C84.6469 81.194 68.7684 78.9859 56.8208 74.9755C44.7534 70.9259 38.1074 65.4928 38.1074 59.6768C38.1074 53.8609 44.7528 48.4277 56.8208 44.3781C68.7684 40.3689 84.6469 38.1597 101.531 38.1597C118.416 38.1597 134.294 40.368 146.242 44.3781C158.309 48.4277 164.955 53.8609 164.955 59.6768C164.955 65.4928 158.309 70.9259 146.242 74.9755C134.294 78.9859 118.415 81.194 101.531 81.194ZM101.531 38.864C84.7215 38.864 68.9233 41.059 57.0461 45.0446C45.2887 48.9901 38.8134 54.187 38.8134 59.6777C38.8134 65.1685 45.2887 70.3653 57.0461 74.3109C68.9233 78.2965 84.7219 80.4914 101.531 80.4914C118.341 80.4914 134.139 78.2965 146.016 74.3109C157.774 70.3653 164.249 65.1685 164.249 59.6777C164.249 54.187 157.774 48.9901 146.016 45.0446C134.139 41.059 118.341 38.864 101.531 38.864Z' fill='%23212529'/%3e%3cpath d='M101.532 72.7801C147.298 72.7801 184.399 62.6235 184.399 50.0947C184.399 37.566 147.298 27.4094 101.532 27.4094C55.7666 27.4094 18.666 37.566 18.666 50.0947C18.666 62.6235 55.7666 72.7801 101.532 72.7801Z' fill='%23FF9C34'/%3e%3cpath d='M101.532 73.1313C79.3669 73.1313 58.5239 70.7671 42.843 66.4742C27.0243 62.1437 18.3125 56.3269 18.3125 50.0938C18.3125 43.8608 27.0243 38.0448 42.843 33.7134C58.5239 29.4206 79.3669 27.0566 101.532 27.0566C123.698 27.0566 144.54 29.4206 160.221 33.7134C176.04 38.0439 184.752 43.8611 184.752 50.0938C184.752 56.3266 176.04 62.1428 160.221 66.4742C144.54 70.7671 123.697 73.1313 101.532 73.1313ZM101.532 27.7607C79.4285 27.7607 58.652 30.1161 43.0302 34.3926C35.4548 36.4663 29.5133 38.8775 25.37 41.559C21.1554 44.287 19.0185 47.1587 19.0185 50.0947C19.0185 53.0308 21.1554 55.9028 25.37 58.6304C29.5133 61.312 35.4548 63.7232 43.0302 65.7971C58.652 70.0742 79.4272 72.4288 101.532 72.4288C123.637 72.4288 144.412 70.0736 160.034 65.7971C167.609 63.7232 173.551 61.312 177.694 58.6304C181.909 55.9028 184.046 53.0308 184.046 50.0947C184.046 47.1587 181.909 44.287 177.694 41.559C173.551 38.8775 167.609 36.4663 160.034 34.3926C144.412 30.1161 123.636 27.7619 101.532 27.7619V27.7607Z' fill='%23212529'/%3e%3cpath d='M139.661 36.8723C139.661 46.901 122.194 49.2635 103.98 49.6927C84.1349 50.1601 63.4062 46.7476 63.4062 36.8723C63.4348 26.8282 67.4644 17.2052 74.6117 10.113C81.759 3.02077 91.4407 -0.961914 101.534 -0.961914C111.628 -0.961914 121.31 3.02077 128.457 10.113C135.604 17.2052 139.634 26.8282 139.662 36.8723H139.661Z' fill='white'/%3e%3cpath d='M134.709 34.8876C134.618 34.8876 134.53 34.8521 134.464 34.7885C134.398 34.725 134.36 34.6385 134.357 34.5473C134.25 30.9474 133.535 27.3911 132.242 24.0272C132.209 23.9401 132.211 23.8435 132.249 23.7584C132.288 23.6733 132.358 23.6068 132.446 23.5735C132.533 23.5402 132.63 23.5428 132.716 23.5808C132.801 23.6188 132.868 23.689 132.901 23.776C134.222 27.2134 134.953 30.8473 135.062 34.5258C135.065 34.6188 135.031 34.7092 134.967 34.7771C134.903 34.8449 134.814 34.8847 134.721 34.8876H134.709Z' fill='%23212529'/%3e%3cpath d='M129.438 18.1388C129.379 18.1389 129.321 18.1244 129.27 18.0965C129.218 18.0686 129.174 18.0283 129.142 17.9793C124.484 10.9036 117.234 5.917 108.936 4.08142C108.847 4.05946 108.77 4.00373 108.721 3.92609C108.673 3.84844 108.656 3.755 108.676 3.66563C108.696 3.57626 108.749 3.49801 108.826 3.44752C108.903 3.39703 108.996 3.37829 109.086 3.39527C117.565 5.27061 124.973 10.3657 129.733 17.5955C129.768 17.6485 129.788 17.7098 129.79 17.773C129.793 17.8362 129.778 17.8989 129.748 17.9546C129.718 18.0102 129.673 18.0567 129.619 18.0891C129.564 18.1216 129.502 18.1387 129.438 18.1388Z' fill='%23212529'/%3e%3cpath d='M100.281 50.0879C83.4238 50.0879 70.5904 47.2669 65.5621 42.3831C63.8956 40.7639 63.0509 38.9098 63.0509 36.8729C63.0367 31.8352 64.0215 26.8442 65.949 22.1859C67.8764 17.5277 70.7086 13.2936 74.2833 9.72639C77.858 6.15919 82.1049 3.32894 86.7807 1.39782C91.4564 -0.533305 96.4692 -1.52734 101.532 -1.52734C106.594 -1.52734 111.607 -0.533305 116.283 1.39782C120.958 3.32894 125.205 6.15919 128.78 9.72639C132.355 13.2936 135.187 17.5277 137.114 22.1859C139.042 26.8442 140.027 31.8352 140.012 36.8729C140.012 41.6035 136.222 45.0849 128.747 47.2205C122.995 48.8636 114.896 49.7873 103.986 50.0443C102.732 50.0734 101.497 50.0879 100.281 50.0879ZM101.531 -0.717638C91.5158 -0.706398 81.9142 3.25756 74.8324 10.3046C67.7506 17.3516 63.7671 26.9063 63.7557 36.8723C63.7557 38.713 64.5291 40.3977 66.0545 41.8798C71.3104 46.9878 85.4827 49.7764 103.969 49.342C119.139 48.985 139.308 47.3033 139.308 36.8732C139.297 26.9069 135.313 17.3521 128.231 10.305C121.149 3.2579 111.547 -0.705889 101.532 -0.716728L101.531 -0.717638Z' fill='%23212529'/%3e%3cpath d='M39.832 53.1306C42.5664 53.1306 44.7831 50.9247 44.7831 48.2037C44.7831 45.4827 42.5664 43.2769 39.832 43.2769C37.0975 43.2769 34.8809 45.4827 34.8809 48.2037C34.8809 50.9247 37.0975 53.1306 39.832 53.1306Z' fill='white'/%3e%3cpath d='M39.8314 53.4825C38.7824 53.4825 37.7569 53.173 36.8846 52.593C36.0124 52.013 35.3326 51.1887 34.9311 50.2242C34.5296 49.2598 34.4246 48.1985 34.6293 47.1747C34.8339 46.1508 35.3391 45.2104 36.0809 44.4722C36.8227 43.734 37.7678 43.2313 38.7967 43.0277C39.8256 42.824 40.892 42.9286 41.8612 43.328C42.8304 43.7275 43.6588 44.404 44.2416 45.272C44.8245 46.14 45.1355 47.1605 45.1355 48.2044C45.1339 49.6037 44.5746 50.9453 43.5802 51.9348C42.5859 52.9243 41.2377 53.4809 39.8314 53.4825ZM39.8314 43.6285C38.922 43.6285 38.0329 43.8969 37.2767 44.3997C36.5205 44.9025 35.9311 45.6171 35.5831 46.4533C35.235 47.2894 35.144 48.2095 35.3214 49.0971C35.4988 49.9847 35.9368 50.8001 36.5799 51.44C37.223 52.08 38.0423 52.5158 38.9343 52.6924C39.8263 52.8689 40.7509 52.7783 41.5912 52.432C42.4314 52.0856 43.1496 51.4991 43.6549 50.7466C44.1602 49.9941 44.4299 49.1094 44.4299 48.2044C44.4286 46.9912 43.9438 45.828 43.0817 44.9701C42.2196 44.1122 41.0506 43.6297 39.8314 43.6285Z' fill='%23212529'/%3e%3cpath d='M101.533 67.2407C104.268 67.2407 106.484 65.0348 106.484 62.3138C106.484 59.5928 104.268 57.387 101.533 57.387C98.7987 57.387 96.582 59.5928 96.582 62.3138C96.582 65.0348 98.7987 67.2407 101.533 67.2407Z' fill='white'/%3e%3cpath d='M101.533 67.5924C100.484 67.5924 99.4581 67.2828 98.5858 66.7029C97.7136 66.1229 97.0337 65.2986 96.6323 64.3341C96.2308 63.3697 96.1258 62.3084 96.3304 61.2845C96.5351 60.2607 97.0403 59.3202 97.782 58.5821C98.5238 57.8439 99.4689 57.3412 100.498 57.1376C101.527 56.9339 102.593 57.0384 103.562 57.4379C104.532 57.8374 105.36 58.5139 105.943 59.3819C106.526 60.2499 106.837 61.2703 106.837 62.3143C106.835 63.7136 106.276 65.0552 105.281 66.0447C104.287 67.0342 102.939 67.5908 101.533 67.5924ZM101.533 57.7387C100.623 57.7387 99.7342 58.007 98.978 58.5098C98.2219 59.0126 97.6325 59.7272 97.2845 60.5633C96.9365 61.3993 96.8454 62.3193 97.0229 63.2069C97.2003 64.0945 97.6382 64.9098 98.2813 65.5497C98.9243 66.1896 99.7436 66.6254 100.636 66.8019C101.528 66.9785 102.452 66.8879 103.292 66.5416C104.132 66.1952 104.851 65.6088 105.356 64.8563C105.861 64.1039 106.131 63.2192 106.131 62.3143C106.129 61.1011 105.645 59.9381 104.783 59.0802C103.921 58.2224 102.752 57.74 101.533 57.7387Z' fill='%23212529'/%3e%3cpath d='M163.223 53.1306C165.957 53.1306 168.174 50.9247 168.174 48.2037C168.174 45.4827 165.957 43.2769 163.223 43.2769C160.488 43.2769 158.271 45.4827 158.271 48.2037C158.271 50.9247 160.488 53.1306 163.223 53.1306Z' fill='white'/%3e%3cpath d='M163.222 53.4825C162.173 53.4825 161.148 53.173 160.275 52.593C159.403 52.013 158.723 51.1887 158.322 50.2242C157.92 49.2598 157.815 48.1985 158.02 47.1747C158.225 46.1508 158.73 45.2104 159.472 44.4722C160.213 43.734 161.158 43.2313 162.187 43.0277C163.216 42.824 164.283 42.9286 165.252 43.328C166.221 43.7275 167.049 44.404 167.632 45.272C168.215 46.14 168.526 47.1605 168.526 48.2044C168.525 49.6037 167.965 50.9453 166.971 51.9348C165.976 52.9243 164.628 53.4809 163.222 53.4825ZM163.222 43.6285C162.313 43.6285 161.424 43.8969 160.667 44.3997C159.911 44.9025 159.322 45.6171 158.974 46.4533C158.626 47.2894 158.535 48.2095 158.712 49.0971C158.889 49.9847 159.327 50.8001 159.971 51.44C160.614 52.08 161.433 52.5158 162.325 52.6924C163.217 52.8689 164.142 52.7783 164.982 52.432C165.822 52.0856 166.54 51.4991 167.045 50.7466C167.551 49.9941 167.82 49.1094 167.82 48.2044C167.819 46.9912 167.334 45.828 166.472 44.9701C165.61 44.1122 164.441 43.6297 163.222 43.6285Z' fill='%23212529'/%3e%3cpath d='M136.91 62.3137C139.644 62.3137 141.861 60.1079 141.861 57.3868C141.861 54.6658 139.644 52.46 136.91 52.46C134.176 52.46 131.959 54.6658 131.959 57.3868C131.959 60.1079 134.176 62.3137 136.91 62.3137Z' fill='white'/%3e%3cpath d='M136.91 62.6654C135.861 62.6654 134.835 62.3558 133.963 61.7758C133.091 61.1959 132.411 60.3715 132.009 59.4071C131.608 58.4426 131.503 57.3814 131.707 56.3575C131.912 55.3337 132.417 54.3932 133.159 53.6551C133.901 52.9169 134.846 52.4142 135.875 52.2106C136.904 52.0069 137.97 52.1114 138.939 52.5109C139.909 52.9104 140.737 53.5869 141.32 54.4549C141.903 55.3229 142.214 56.3433 142.214 57.3872C142.212 58.7866 141.653 60.1282 140.658 61.1177C139.664 62.1072 138.316 62.6638 136.91 62.6654ZM136.91 52.8114C136 52.8113 135.111 53.0796 134.355 53.5824C133.599 54.0852 133.009 54.7998 132.661 55.6359C132.313 56.4721 132.222 57.3921 132.399 58.2798C132.577 59.1674 133.015 59.9828 133.658 60.6228C134.301 61.2628 135.12 61.6986 136.012 61.8752C136.904 62.0518 137.829 61.9612 138.669 61.6148C139.509 61.2685 140.227 60.682 140.733 59.9295C141.238 59.177 141.508 58.2923 141.508 57.3872C141.506 56.1741 141.022 55.0109 140.16 54.153C139.298 53.2952 138.129 52.8127 136.91 52.8114Z' fill='%23212529'/%3e%3cpath d='M66.1562 62.9843C68.8906 62.9843 71.1073 60.7785 71.1073 58.0575C71.1073 55.3364 68.8906 53.1306 66.1562 53.1306C63.4218 53.1306 61.2051 55.3364 61.2051 58.0575C61.2051 60.7785 63.4218 62.9843 66.1562 62.9843Z' fill='white'/%3e%3cpath d='M66.1556 63.3365C65.1066 63.3365 64.0811 63.0269 63.2089 62.447C62.3366 61.867 61.6568 61.0427 61.2553 60.0782C60.8539 59.1138 60.7488 58.0525 60.9535 57.0287C61.1581 56.0048 61.6633 55.0644 62.4051 54.3262C63.1469 53.588 64.092 53.0853 65.1209 52.8817C66.1498 52.678 67.2162 52.7826 68.1854 53.1821C69.1546 53.5815 69.983 54.258 70.5658 55.126C71.1486 55.994 71.4597 57.0145 71.4597 58.0584C71.4581 59.4577 70.8988 60.7993 69.9044 61.7888C68.9101 62.7783 67.5619 63.3349 66.1556 63.3365ZM66.1556 53.4825C65.2461 53.4822 64.3569 53.7503 63.6005 54.253C62.8441 54.7556 62.2544 55.4702 61.9062 56.3063C61.5579 57.1424 61.4666 58.0625 61.6439 58.9503C61.8212 59.838 62.2591 60.6535 62.9021 61.2936C63.5452 61.9337 64.3646 62.3696 65.2566 62.5463C66.1487 62.7229 67.0734 62.6323 67.9137 62.286C68.754 61.9397 69.4723 61.3531 69.9776 60.6006C70.4829 59.848 70.7526 58.9632 70.7525 58.0581C70.7512 56.8452 70.2665 55.6823 69.4048 54.8245C68.543 53.9667 67.3745 53.4841 66.1556 53.4825Z' fill='%23212529'/%3e%3cpath d='M154.031 32.5419C153.662 33.654 152.907 34.599 151.902 35.2075C150.896 35.816 149.706 36.0482 148.544 35.8624C147.382 35.6767 146.324 35.0852 145.561 34.1939C144.797 33.3027 144.377 32.17 144.377 30.9988C144.377 30.8887 144.382 30.781 144.389 30.6733C147.77 31.2354 150.992 31.8582 154.031 32.5419Z' fill='white'/%3e%3cpath d='M149.328 36.277C147.921 36.2756 146.573 35.7191 145.578 34.7295C144.584 33.74 144.025 32.3983 144.023 30.9988C144.023 30.8811 144.028 30.7656 144.036 30.6503L144.062 30.2629L144.446 30.3269C147.846 30.8921 151.097 31.5221 154.109 32.1992L154.489 32.2847L154.367 32.652C154.018 33.7078 153.343 34.6268 152.438 35.2778C151.533 35.9288 150.444 36.2785 149.328 36.277ZM144.731 31.0871C144.751 32.1338 145.131 33.1418 145.808 33.9431C146.485 34.7445 147.418 35.2907 148.45 35.4906C149.483 35.6906 150.553 35.5322 151.483 35.0419C152.412 34.5517 153.145 33.7591 153.558 32.7964C150.79 32.1822 147.825 31.608 144.731 31.0871Z' fill='%23212529'/%3e%3cpath d='M58.1537 30.9988C58.1534 32.1601 57.741 33.2839 56.9892 34.1721C56.2374 35.0602 55.1946 35.6557 54.0447 35.8534C52.8948 36.051 51.7116 35.8383 50.704 35.2526C49.6963 34.6668 48.9289 33.7458 48.5371 32.652C51.5653 31.9634 54.7749 31.3313 58.1467 30.7622C58.1512 30.8396 58.1537 30.919 58.1537 30.9988Z' fill='white'/%3e%3cpath d='M53.2031 36.2768C52.1085 36.2753 51.0411 35.9377 50.1464 35.3102C49.2517 34.6827 48.5733 33.7958 48.2038 32.7705L48.0703 32.398L48.4578 32.31C51.5009 31.6181 54.7407 30.9811 58.0868 30.4166L58.4746 30.3511L58.4983 30.7415C58.5035 30.8258 58.506 30.9126 58.506 30.9993C58.5043 32.3984 57.9452 33.7397 56.951 34.7291C55.9569 35.7185 54.6091 36.2751 53.2031 36.2768ZM49.0205 32.9034C49.4509 33.839 50.1856 34.6029 51.106 35.0718C52.0264 35.5408 53.0788 35.6874 54.0932 35.488C55.1077 35.2887 56.025 34.7549 56.6971 33.973C57.3692 33.191 57.7569 32.2065 57.7975 31.1783C54.7565 31.6982 51.8082 32.2776 49.0205 32.9034Z' fill='%23212529'/%3e%3cpath d='M109.233 202.993L63.9727 177.336L98.998 116.152L130.295 133.893L136.304 155.704L109.233 202.993Z' fill='white'/%3e%3cpath opacity='0.3' d='M116.577 172.517C118.066 172.517 119.273 171.316 119.273 169.835C119.273 168.353 118.066 167.152 116.577 167.152C115.088 167.152 113.881 168.353 113.881 169.835C113.881 171.316 115.088 172.517 116.577 172.517Z' fill='%23FF9C34'/%3e%3cpath opacity='0.3' d='M88.1256 158.387C89.6146 158.387 90.8216 157.186 90.8216 155.705C90.8216 154.223 89.6146 153.022 88.1256 153.022C86.6367 153.022 85.4297 154.223 85.4297 155.705C85.4297 157.186 86.6367 158.387 88.1256 158.387Z' fill='%23FF9C34'/%3e%3cpath d='M109.366 203.472L63.4922 177.468L98.8668 115.674L130.597 133.662L136.684 155.753L109.366 203.472ZM64.4549 177.206L109.102 202.514L135.927 155.657L129.995 134.127L99.1311 116.632L64.4549 177.206Z' fill='%23212529'/%3e%3cpath opacity='0.3' d='M130.296 133.894L122.342 147.789L136.306 155.705L130.296 133.894Z' fill='%23FF9C34'/%3e%3cpath d='M136.305 156.056C136.244 156.056 136.184 156.04 136.13 156.01L122.166 148.094C122.085 148.048 122.025 147.972 122.001 147.882C121.976 147.792 121.988 147.696 122.035 147.615L129.989 133.719C130.024 133.658 130.075 133.61 130.138 133.578C130.2 133.547 130.271 133.535 130.34 133.544C130.409 133.553 130.474 133.582 130.527 133.627C130.58 133.673 130.618 133.733 130.636 133.8L136.646 155.61C136.66 155.662 136.662 155.717 136.652 155.77C136.641 155.823 136.619 155.873 136.586 155.916C136.553 155.959 136.51 155.993 136.462 156.017C136.413 156.041 136.359 156.054 136.305 156.054V156.056ZM122.823 147.658L135.739 154.98L130.181 134.804L122.823 147.658Z' fill='%23212529'/%3e%3cpath d='M97.1863 152.175C98.3614 152.175 99.3141 151.227 99.3141 150.058C99.3141 148.888 98.3614 147.94 97.1863 147.94C96.0112 147.94 95.0586 148.888 95.0586 150.058C95.0586 151.227 96.0112 152.175 97.1863 152.175Z' fill='%23212529'/%3e%3cpath d='M117.143 161.205C118.318 161.205 119.271 160.257 119.271 159.088C119.271 157.919 118.318 156.971 117.143 156.971C115.968 156.971 115.016 157.919 115.016 159.088C115.016 160.257 115.968 161.205 117.143 161.205Z' fill='%23212529'/%3e%3cpath d='M108.1 174.191C108.008 174.191 107.92 174.156 107.854 174.092C107.788 174.028 107.75 173.941 107.747 173.85C107.703 172.157 107.225 170.503 106.358 169.045C105.492 167.587 104.266 166.373 102.796 165.519C101.327 164.664 99.6622 164.197 97.9605 164.162C96.2588 164.127 94.5762 164.524 93.0721 165.317C93.031 165.34 92.9857 165.354 92.939 165.36C92.8922 165.365 92.8449 165.361 92.7998 165.347C92.7547 165.334 92.7127 165.312 92.6763 165.282C92.6399 165.253 92.6098 165.216 92.5878 165.175C92.5658 165.133 92.5524 165.088 92.5482 165.041C92.5441 164.995 92.5494 164.948 92.5638 164.903C92.5782 164.858 92.6014 164.817 92.632 164.782C92.6627 164.746 92.7001 164.717 92.7422 164.696C94.3525 163.848 96.1537 163.423 97.9753 163.461C99.7969 163.499 101.579 163.999 103.152 164.914C104.725 165.828 106.037 167.127 106.965 168.688C107.893 170.248 108.405 172.018 108.453 173.831C108.455 173.924 108.421 174.014 108.356 174.082C108.292 174.149 108.203 174.189 108.11 174.191H108.1Z' fill='%23212529'/%3e%3cpath d='M99.0366 147.891C97.8905 147.877 96.7723 147.538 95.8127 146.914C95.7372 146.86 95.6862 146.778 95.6708 146.687C95.6555 146.595 95.677 146.502 95.7308 146.426C95.7845 146.35 95.8661 146.299 95.9578 146.283C96.0495 146.267 96.1438 146.287 96.2203 146.34C96.2483 146.36 98.3191 147.774 100.633 146.895C100.72 146.864 100.815 146.868 100.899 146.907C100.982 146.945 101.048 147.015 101.081 147.101C101.113 147.186 101.111 147.281 101.075 147.365C101.038 147.45 100.97 147.516 100.885 147.551C100.295 147.776 99.6684 147.892 99.0366 147.891Z' fill='%23212529'/%3e%3cpath d='M120.831 157.986C120.792 157.986 120.752 157.979 120.715 157.967C117.739 156.935 117.401 154.651 117.388 154.555C117.375 154.462 117.4 154.368 117.457 154.294C117.514 154.22 117.598 154.171 117.691 154.159C117.784 154.146 117.878 154.171 117.953 154.228C118.028 154.284 118.077 154.368 118.089 154.46C118.101 154.544 118.402 156.42 120.949 157.303C121.027 157.331 121.094 157.385 121.136 157.456C121.178 157.528 121.194 157.612 121.18 157.693C121.166 157.775 121.124 157.849 121.06 157.903C120.997 157.956 120.916 157.986 120.833 157.986H120.831Z' fill='%23212529'/%3e%3cpath d='M3.60284 76.3014C3.5565 76.3014 3.51061 76.2923 3.4678 76.2746C3.42499 76.257 3.3861 76.2311 3.35335 76.1985C3.32059 76.1658 3.29462 76.1271 3.27691 76.0845C3.25921 76.0419 3.25011 75.9962 3.25015 75.9501V66.0403C3.24876 65.9933 3.25686 65.9465 3.27397 65.9027C3.29108 65.8589 3.31685 65.819 3.34975 65.7853C3.38265 65.7516 3.42202 65.7248 3.46552 65.7065C3.50902 65.6881 3.55577 65.6787 3.603 65.6787C3.65023 65.6787 3.69697 65.6881 3.74047 65.7065C3.78397 65.7248 3.82334 65.7516 3.85624 65.7853C3.88914 65.819 3.91491 65.8589 3.93202 65.9027C3.94913 65.9465 3.95723 65.9933 3.95584 66.0403V75.9501C3.95588 75.9962 3.94678 76.0419 3.92905 76.0846C3.91133 76.1272 3.88533 76.1659 3.85254 76.1986C3.81975 76.2312 3.78082 76.2571 3.73798 76.2747C3.69513 76.2923 3.64921 76.3014 3.60284 76.3014Z' fill='%23212529'/%3e%3cpath d='M6.85173 71.3455H0.352997C0.259376 71.3455 0.16959 71.3085 0.10339 71.2427C0.0371906 71.177 0 71.0878 0 70.9948C0 70.9017 0.0371906 70.8125 0.10339 70.7468C0.16959 70.681 0.259376 70.644 0.352997 70.644H6.85173C6.94535 70.644 7.03514 70.681 7.10134 70.7468C7.16754 70.8125 7.20473 70.9017 7.20473 70.9948C7.20473 71.0878 7.16754 71.177 7.10134 71.2427C7.03514 71.3085 6.94535 71.3455 6.85173 71.3455Z' fill='%23212529'/%3e%3cpath d='M173.115 131.495C173.021 131.495 172.931 131.458 172.865 131.392C172.799 131.326 172.762 131.237 172.762 131.144V116.07C172.762 115.977 172.799 115.887 172.865 115.821C172.931 115.756 173.021 115.719 173.115 115.719C173.208 115.719 173.298 115.756 173.364 115.821C173.431 115.887 173.468 115.977 173.468 116.07V131.144C173.468 131.237 173.43 131.326 173.364 131.392C173.298 131.458 173.208 131.495 173.115 131.495Z' fill='%23212529'/%3e%3cpath d='M178.059 123.957H168.173C168.08 123.957 167.99 123.92 167.924 123.854C167.857 123.789 167.82 123.699 167.82 123.606C167.82 123.513 167.857 123.424 167.924 123.358C167.99 123.293 168.08 123.256 168.173 123.256H178.059C178.153 123.256 178.242 123.293 178.309 123.358C178.375 123.424 178.412 123.513 178.412 123.606C178.412 123.699 178.375 123.789 178.309 123.854C178.242 123.92 178.153 123.957 178.059 123.957Z' fill='%23212529'/%3e%3cpath d='M197.175 83.8385C197.129 83.8386 197.083 83.8295 197.04 83.8119C196.997 83.7942 196.958 83.7684 196.926 83.7357C196.893 83.7031 196.867 83.6644 196.849 83.6217C196.831 83.5791 196.822 83.5334 196.822 83.4873V75.9501C196.822 75.857 196.859 75.7676 196.926 75.7018C196.992 75.6359 197.082 75.5989 197.175 75.5989C197.269 75.5989 197.359 75.6359 197.425 75.7018C197.491 75.7676 197.528 75.857 197.528 75.9501V83.4873C197.528 83.5334 197.519 83.5791 197.501 83.6217C197.484 83.6644 197.458 83.7031 197.425 83.7357C197.392 83.7684 197.353 83.7942 197.31 83.8119C197.268 83.8295 197.222 83.8386 197.175 83.8385Z' fill='%23212529'/%3e%3cpath d='M199.647 80.0691H194.705C194.658 80.0691 194.612 80.06 194.569 80.0424C194.527 80.0248 194.488 79.9989 194.455 79.9664C194.422 79.9338 194.396 79.8952 194.378 79.8526C194.361 79.81 194.352 79.7644 194.352 79.7184C194.352 79.6723 194.361 79.6267 194.378 79.5842C194.396 79.5416 194.422 79.503 194.455 79.4704C194.488 79.4378 194.527 79.412 194.569 79.3944C194.612 79.3767 194.658 79.3677 194.705 79.3677H199.647C199.741 79.3677 199.831 79.4046 199.897 79.4704C199.963 79.5362 200 79.6254 200 79.7184C200 79.8114 199.963 79.9006 199.897 79.9664C199.831 80.0321 199.741 80.0691 199.647 80.0691Z' fill='%23212529'/%3e%3c/g%3e%3cdefs%3e%3cclipPath id='clip0_104_14723'%3e%3crect width='200' height='220' fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e";

function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var withMinimumScreenWidth = function(minimumWidth) {
    var emptyGraphic = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    return function(WrappedComponent) {
        var WidthMinimumScreenWidth = function WidthMinimumScreenWidth(props) {
            var _useState = _sliced_to_array(useState(window.innerWidth), 2), width = _useState[0], setWidth = _useState[1];
            var history = useHistory();
            useEffect(function() {
                var listener = function() {
                    setWidth(window.innerWidth);
                };
                window.addEventListener('resize', listener);
                return function() {
                    window.removeEventListener('resize', listener);
                };
            }, []);
            if (width < minimumWidth) {
                if (emptyGraphic) {
                    return /*#__PURE__*/ React.createElement("div", {
                        className: "too-small-screen"
                    }, /*#__PURE__*/ React.createElement("img", {
                        src: img,
                        alt: "Too Small"
                    }), /*#__PURE__*/ React.createElement("div", {
                        className: "title"
                    }, i18next.t('common.minimumScreenWidth.title')), /*#__PURE__*/ React.createElement("div", {
                        className: "sub-title"
                    }, i18next.t('common.minimumScreenWidth.subTitle')), /*#__PURE__*/ React.createElement(Button, {
                        onClick: function() {
                            history.goBack();
                        }
                    }, i18next.t('common.minimumScreenWidth.button')));
                }
                return null;
            }
            return /*#__PURE__*/ React.createElement(WrappedComponent, props);
        };
        return WidthMinimumScreenWidth;
    };
};

function useHandleClickOutside(refs, onClick) {
    // If ref.current is not present, then we can assume that it is always outside
    var isOutside = function(event, ref) {
        return ref.current ? !ref.current.contains(event.target) : true;
    };
    var handleClickOutside = useCallback(function(event) {
        if (Array.isArray(refs)) {
            // If pass multiple refs, check if none of them are clicked
            var shouldNotCallOnClick = false;
            refs.forEach(function(ref) {
                if (!isOutside(event, ref)) {
                    shouldNotCallOnClick = true;
                }
            });
            if (!shouldNotCallOnClick) {
                onClick(event);
            }
        } else if (isOutside(event, refs)) {
            // Or one ref
            onClick(event);
        }
    }, [
        onClick
    ]);
    useEffect(function() {
        document.addEventListener('mousedown', handleClickOutside);
        return function() {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [
        handleClickOutside
    ]);
    return null;
}

function _class_call_check$2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _define_property$2(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var Storage = function Storage(prefix) {
    var _this = this;
    _class_call_check$2(this, Storage);
    _define_property$2(this, "getStorageKey", function(key) {
        return "".concat(_this.prefix, ".").concat(key);
    });
    _define_property$2(this, "getItem", function(key) {
        return localStorage.getItem(_this.getStorageKey(key));
    });
    _define_property$2(this, "setItem", function(key, value) {
        return localStorage.setItem(_this.getStorageKey(key), value);
    });
    _define_property$2(this, "removeItem", function(key) {
        return localStorage.removeItem(_this.getStorageKey(key));
    });
    _define_property$2(this, "getJson", function(key) {
        var value = _this.getItem(key);
        try {
            return JSON.parse(value);
        } catch (error) {
            return value;
        }
    });
    _define_property$2(this, "setJson", function(key, value) {
        return _this.setItem(key, JSON.stringify(value));
    });
    _define_property$2(this, "setCookie", function(key, value) {
        Cookies.set(_this.getStorageKey(key), value, {
            expires: 365,
            path: '/',
            secure: true
        });
    });
    _define_property$2(this, "getCookie", function(key) {
        return Cookies.get(_this.getStorageKey(key));
    });
    _define_property$2(this, "removeCookie", function(key) {
        Cookies.remove(_this.getStorageKey(key), {
            path: '/'
        });
    });
    this.prefix = prefix;
};

function _class_call_check$1(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _define_property$1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var Auth = function Auth(storage) {
    var _this = this;
    _class_call_check$1(this, Auth);
    _define_property$1(this, "getToken", function() {
        var _this_data;
        return (_this_data = _this.data) === null || _this_data === void 0 ? void 0 : _this_data.accessToken;
    });
    _define_property$1(this, "isAuth", function() {
        return !!_this.getToken();
    });
    _define_property$1(this, "setAuth", function(input) {
        _this.data = input;
        _this.storage.setJson('authorization', _this.data);
        _this.storage.setCookie('Authorization', "Bearer ".concat(_this.data.accessToken));
    });
    _define_property$1(this, "logout", function() {
        _this.data = {};
        _this.storage.removeItem('authorization');
        _this.storage.removeCookie('Authorization');
    });
    this.storage = storage;
    this.data = storage.getJson('authorization');
};

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var addBreadCrumb = function(method, endpoint, params, headers, response) {
    Sentry.addBreadcrumb({
        data: {
            endpoint: endpoint,
            method: method,
            response: JSON.stringify(response),
            params: JSON.stringify(params),
            headers: JSON.stringify(headers)
        },
        category: 'Network',
        level: 'info'
    });
};
var defaultHeaders = {
    Accept: 'application/json',
    'Content-Type': 'application/json'
};
function ServerAPIError(json, code) {
    this.name = 'ServerAPIError';
    this.data = json;
    this.code = code;
    this.stack = new Error().stack;
}
ServerAPIError.prototype = Object.create(Error.prototype);
ServerAPIError.prototype.constructor = ServerAPIError;
var Request = function Request(apiUrl, auth, tenantId) {
    var _this = this;
    _class_call_check(this, Request);
    var _this1 = this;
    _define_property(this, "request", function() {
        var _ref = _async_to_generator(function(url, method, body) {
            var customHeaders, endpoint, headers, token, _$tenantId, fetchOpts, start, response, end, responseTime, json, logData;
            var _arguments = arguments;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        customHeaders = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : {};
                        endpoint = url;
                        if (!url.startsWith('http')) {
                            endpoint = _this1.apiUrl + url;
                        }
                        headers = _object_spread({}, defaultHeaders, customHeaders);
                        token = _this1.auth.getToken();
                        if (token) {
                            // Set empty Bearer can cause setRequestHeader error in old safari version
                            headers.Authorization = "Bearer ".concat(token);
                        }
                        _$tenantId = _this1.tenantId;
                        if (_$tenantId) {
                            headers['x-tenant-id'] = _$tenantId;
                        }
                        fetchOpts = {
                            method: method,
                            headers: headers
                        };
                        if (method !== 'HEAD' && method !== 'GET') {
                            if (headers['Content-Type'] === 'application/json') {
                                fetchOpts.body = JSON.stringify(body);
                            } else {
                                delete headers['Content-Type'];
                                fetchOpts.body = body;
                            }
                        }
                        start = Date.now();
                        return [
                            4,
                            fetch(endpoint, fetchOpts)
                        ];
                    case 1:
                        response = _state.sent();
                        end = Date.now();
                        responseTime = end - start;
                        return [
                            4,
                            response.json()
                        ];
                    case 2:
                        json = _state.sent();
                        logData = {
                            method: method,
                            url: endpoint,
                            status: response.status,
                            responseTime: responseTime
                        };
                        if (response.status < 200 || response.status >= 300) {
                            if (json) {
                                logData.error = json;
                                addBreadCrumb(method, endpoint, body, headers, json);
                                throw new ServerAPIError(json, response.status);
                            } else {
                                logData.error = response.statusText;
                                addBreadCrumb(method, endpoint, body, headers, response.statusText);
                                throw new Error(response.statusText);
                            }
                        }
                        addBreadCrumb(method, endpoint, body, headers, json);
                        return [
                            2,
                            json
                        ];
                }
            });
        });
        return function(url, method, body) {
            return _ref.apply(this, arguments);
        };
    }());
    _define_property(this, "get", function(endpoint, params) {
        var headers = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        var url = endpoint;
        if (params) {
            url += "?".concat(QueryString.stringify(params));
        }
        return _this.request(url, 'GET', null, headers);
    });
    _define_property(this, "post", function(endpoint, body) {
        var headers = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        return _this.request(endpoint, 'POST', body, headers);
    });
    _define_property(this, "put", function(endpoint, body) {
        var headers = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        return _this.request(endpoint, 'PUT', body, headers);
    });
    _define_property(this, "del", function(endpoint, body) {
        var headers = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        return _this.request(endpoint, 'DELETE', body, headers);
    });
    this.apiUrl = apiUrl;
    this.auth = auth;
    this.tenantId = tenantId;
};

var getLocaleDateString = function() {
    var formats = {
        'af-ZA': 'yyyy/MM/DD',
        'am-ET': 'D/M/yyyy',
        'ar-AE': 'DD/MM/yyyy',
        'ar-BH': 'DD/MM/yyyy',
        'ar-DZ': 'DD-MM-yyyy',
        'ar-EG': 'DD/MM/yyyy',
        'ar-IQ': 'DD/MM/yyyy',
        'ar-JO': 'DD/MM/yyyy',
        'ar-KW': 'DD/MM/yyyy',
        'ar-LB': 'DD/MM/yyyy',
        'ar-LY': 'DD/MM/yyyy',
        'ar-MA': 'DD-MM-yyyy',
        'ar-OM': 'DD/MM/yyyy',
        'ar-QA': 'DD/MM/yyyy',
        'ar-SA': 'DD/MM/yy',
        'ar-SY': 'DD/MM/yyyy',
        'ar-TN': 'DD-MM-yyyy',
        'ar-YE': 'DD/MM/yyyy',
        'arn-CL': 'DD-MM-yyyy',
        'as-IN': 'DD-MM-yyyy',
        'az-Cyrl-AZ': 'DD.MM.yyyy',
        'az-Latn-AZ': 'DD.MM.yyyy',
        'ba-RU': 'DD.MM.yy',
        'be-BY': 'DD.MM.yyyy',
        'bg-BG': 'DD.M.yyyy',
        'bn-BD': 'DD-MM-yy',
        'bn-IN': 'DD-MM-yy',
        'bo-CN': 'yyyy/M/D',
        'br-FR': 'DD/MM/yyyy',
        'bs-Cyrl-BA': 'D.M.yyyy',
        'bs-Latn-BA': 'D.M.yyyy',
        'ca-ES': 'DD/MM/yyyy',
        'co-FR': 'DD/MM/yyyy',
        'cs-CZ': 'D.M.yyyy',
        'cy-GB': 'DD/MM/yyyy',
        'da-DK': 'DD-MM-yyyy',
        'de-AT': 'DD.MM.yyyy',
        'de-CH': 'DD.MM.yyyy',
        'de-DE': 'DD.MM.yyyy',
        'de-LI': 'DD.MM.yyyy',
        'de-LU': 'DD.MM.yyyy',
        'dsb-DE': 'D. M. yyyy',
        'dv-MV': 'DD/MM/yy',
        'el-GR': 'D/M/yyyy',
        'en-029': 'MM/DD/yyyy',
        'en-AU': 'D/MM/yyyy',
        'en-BZ': 'DD/MM/yyyy',
        'en-CA': 'DD/MM/yyyy',
        'en-GB': 'DD/MM/yyyy',
        'en-IE': 'DD/MM/yyyy',
        'en-IN': 'DD-MM-yyyy',
        'en-JM': 'DD/MM/yyyy',
        'en-MY': 'D/M/yyyy',
        'en-NZ': 'D/MM/yyyy',
        'en-PH': 'M/D/yyyy',
        'en-SG': 'D/M/yyyy',
        'en-TT': 'DD/MM/yyyy',
        'en-US': 'M/D/yyyy',
        'en-ZA': 'yyyy/MM/DD',
        'en-ZW': 'M/D/yyyy',
        'es-AR': 'DD/MM/yyyy',
        'es-BO': 'DD/MM/yyyy',
        'es-CL': 'DD-MM-yyyy',
        'es-CO': 'DD/MM/yyyy',
        'es-CR': 'DD/MM/yyyy',
        'es-DO': 'DD/MM/yyyy',
        'es-EC': 'DD/MM/yyyy',
        'es-ES': 'DD/MM/yyyy',
        'es-GT': 'DD/MM/yyyy',
        'es-HN': 'DD/MM/yyyy',
        'es-MX': 'DD/MM/yyyy',
        'es-NI': 'DD/MM/yyyy',
        'es-PA': 'MM/DD/yyyy',
        'es-PE': 'DD/MM/yyyy',
        'es-PR': 'DD/MM/yyyy',
        'es-PY': 'DD/MM/yyyy',
        'es-SV': 'DD/MM/yyyy',
        'es-US': 'M/D/yyyy',
        'es-UY': 'DD/MM/yyyy',
        'es-VE': 'DD/MM/yyyy',
        'et-EE': 'D.MM.yyyy',
        'eu-ES': 'yyyy/MM/DD',
        'fa-IR': 'MM/DD/yyyy',
        'fi-FI': 'D.M.yyyy',
        'fil-PH': 'M/D/yyyy',
        'fo-FO': 'DD-MM-yyyy',
        'fr-BE': 'D/MM/yyyy',
        'fr-CA': 'yyyy-MM-DD',
        'fr-CH': 'DD.MM.yyyy',
        'fr-FR': 'DD/MM/yyyy',
        'fr-LU': 'DD/MM/yyyy',
        'fr-MC': 'DD/MM/yyyy',
        'fy-NL': 'd-M-yyyy',
        'ga-IE': 'DD/MM/yyyy',
        'gd-GB': 'DD/MM/yyyy',
        'gl-ES': 'DD/MM/yy',
        'gsw-FR': 'DD/MM/yyyy',
        'gu-IN': 'DD-MM-yy',
        'ha-Latn-NG': 'D/M/yyyy',
        'he-IL': 'DD/MM/yyyy',
        'hi-IN': 'DD-MM-yyyy',
        'hr-BA': 'D.M.yyyy.',
        'hr-HR': 'D.M.yyyy',
        'hsb-DE': 'D. M. yyyy',
        'hu-HU': 'yyyy. MM. DD.',
        'hy-AM': 'DD.MM.yyyy',
        'id-ID': 'DD/MM/yyyy',
        'ig-NG': 'D/M/yyyy',
        'ii-CN': 'yyyy/M/D',
        'is-IS': 'D.M.yyyy',
        'it-CH': 'DD.MM.yyyy',
        'it-IT': 'DD/MM/yyyy',
        'iu-Cans-CA': 'D/M/yyyy',
        'iu-Latn-CA': 'D/MM/yyyy',
        'ja-JP': 'yyyy/MM/DD',
        'ka-GE': 'DD.MM.yyyy',
        'kk-KZ': 'DD.MM.yyyy',
        'kl-GL': 'DD-MM-yyyy',
        'km-KH': 'yyyy-MM-DD',
        'kn-IN': 'DD-MM-yy',
        'ko-KR': 'yyyy. MM. DD',
        'kok-IN': 'DD-MM-yyyy',
        'ky-KG': 'DD.MM.yy',
        'lb-LU': 'DD/MM/yyyy',
        'lo-LA': 'DD/MM/yyyy',
        'lt-LT': 'yyyy.MM.DD',
        'lv-LV': 'yyyy.MM.DD.',
        'mi-NZ': 'DD/MM/yyyy',
        'mk-MK': 'DD.MM.yyyy',
        'ml-IN': 'DD-MM-yy',
        'mn-MN': 'yy.MM.DD',
        'mn-Mong-CN': 'yyyy/M/D',
        'moh-CA': 'M/D/yyyy',
        'mr-IN': 'DD-MM-yyyy',
        'ms-BN': 'DD/MM/yyyy',
        'ms-MY': 'DD/MM/yyyy',
        'mt-MT': 'DD/MM/yyyy',
        'nb-NO': 'DD.MM.yyyy',
        'ne-NP': 'M/D/yyyy',
        'nl-BE': 'D/MM/yyyy',
        'nl-NL': 'd-M-yyyy',
        'nn-NO': 'DD.MM.yyyy',
        'nso-ZA': 'yyyy/MM/DD',
        'oc-FR': 'DD/MM/yyyy',
        'or-IN': 'DD-MM-yy',
        'pa-IN': 'DD-MM-yy',
        'pl-PL': 'DD.MM.yyyy',
        'prs-AF': 'DD/MM/yy',
        'ps-AF': 'DD/MM/yy',
        'pt-BR': 'D/M/yyyy',
        'pt-PT': 'DD-MM-yyyy',
        'qut-GT': 'DD/MM/yyyy',
        'quz-BO': 'DD/MM/yyyy',
        'quz-EC': 'DD/MM/yyyy',
        'quz-PE': 'DD/MM/yyyy',
        'rm-CH': 'DD/MM/yyyy',
        'ro-RO': 'DD.MM.yyyy',
        'ru-RU': 'DD.MM.yyyy',
        'rw-RW': 'M/D/yyyy',
        'sa-IN': 'DD-MM-yyyy',
        'sah-RU': 'MM.DD.yyyy',
        'se-FI': 'D.M.yyyy',
        'se-NO': 'DD.MM.yyyy',
        'se-SE': 'yyyy-MM-DD',
        'si-LK': 'yyyy-MM-DD',
        'sk-SK': 'D. M. yyyy',
        'sl-SI': 'D.M.yyyy',
        'sma-NO': 'DD.MM.yyyy',
        'sma-SE': 'yyyy-MM-DD',
        'smj-NO': 'DD.MM.yyyy',
        'smj-SE': 'yyyy-MM-DD',
        'smn-FI': 'D.M.yyyy',
        'sms-FI': 'D.M.yyyy',
        'sq-AL': 'yyyy-MM-DD',
        'sr-Cyrl-BA': 'D.M.yyyy',
        'sr-Cyrl-CS': 'D.M.yyyy',
        'sr-Cyrl-ME': 'D.M.yyyy',
        'sr-Cyrl-RS': 'D.M.yyyy',
        'sr-Latn-BA': 'D.M.yyyy',
        'sr-Latn-CS': 'D.M.yyyy',
        'sr-Latn-ME': 'D.M.yyyy',
        'sr-Latn-RS': 'D.M.yyyy',
        'sv-FI': 'D.M.yyyy',
        'sv-SE': 'yyyy-MM-DD',
        'sw-KE': 'M/D/yyyy',
        'syr-SY': 'DD/MM/yyyy',
        'ta-IN': 'DD-MM-yyyy',
        'te-IN': 'DD-MM-yy',
        'tg-Cyrl-TJ': 'DD.MM.yy',
        'th-TH': 'D/M/yyyy',
        'tk-TM': 'DD.MM.yy',
        'tn-ZA': 'yyyy/MM/DD',
        'tr-TR': 'DD.MM.yyyy',
        'tt-RU': 'DD.MM.yyyy',
        'tzm-Latn-DZ': 'DD-MM-yyyy',
        'ug-CN': 'yyyy-M-d',
        'uk-UA': 'DD.MM.yyyy',
        'ur-PK': 'DD/MM/yyyy',
        'uz-Cyrl-UZ': 'DD.MM.yyyy',
        'uz-Latn-UZ': 'DD/MM yyyy',
        'vi-VN': 'DD/MM/yyyy',
        'wo-SN': 'DD/MM/yyyy',
        'xh-ZA': 'yyyy/MM/DD',
        'yo-NG': 'D/M/yyyy',
        'zh-CN': 'yyyy/M/D',
        'zh-HK': 'D/M/yyyy',
        'zh-MO': 'D/M/yyyy',
        'zh-SG': 'D/M/yyyy',
        'zh-TW': 'yyyy/M/D',
        'zu-ZA': 'yyyy/MM/DD'
    };
    return formats[navigator.language] || 'DD/MM/yyyy';
};

var mobile = {
	checkout: {
		title: "Checkout",
		missingFloorPlanId: "Floor plan ID is required",
		paymentProcessing: "Processing your payment...",
		paymentSuccess: "Payment successful!",
		paymentError: "Payment failed. Please try again.",
		orderSumary: "Order summary",
		totalPrice: "Total price",
		"package": "Package",
		quantity: "Quantity",
		unitPrice: "Unit price",
		price: "Price",
		free: "Free"
	}
};
var auth = {
	getStarted: {
		enterEmailToGetStarted: "Enter your email to get started",
		logIntoAccount: "Log into your account to have the best experience with us",
		enterYourEmail: "Enter your email..."
	},
	login: {
		yayWeFoundYou: "Yay! we found you",
		enterYourPasswordToCompleteLogin: "Enter your password to complete the login",
		enterYourPassword: "Enter your password",
		forgotYourPassword: "Forgot your password?",
		resetYourPassword: "Reset your password",
		yourEmail: "Your email",
		emailMeARecoveryLink: "Email me a recovery link",
		sendEmailSuccess: "We received your message and will response you in 1 working day",
		sentARecoveryLink: "We've sent a recovery link to your email."
	},
	signup: {
		weCantFindYourAccount: "We can't find your account"
	},
	resetPassword: {
		passwordValidation: "Password must be at least 8 characters with mixture of uppercase, lowercase, numeric and inclusion of at least one special character",
		passwordNotMatch: "Password confirmation does not match.",
		resetPasswordSuccess: "Reset password successfully",
		enterYourNewPassword: "Enter your new password",
		newPassword: "New Password",
		newPasswordConfirmation: "New Password Confirmation",
		setPassword: "Set password"
	}
};
var homepage = {
	intro: {
		VIRTUAL: "VIRTUAL",
		STAGING: "STAGING",
		SLOGAN_1: "Betates is the simplest way to virtually stage your property",
		SLOGAN_2: "DO IT YOURSELF",
		TRY_NOW: "TRY NOW",
		FREE_FOR_1ST: "FREE FOR 1ST",
		IMAGE: "IMAGE"
	},
	pricing: {
		title1: "Full control",
		title2: "with affordable price",
		"2D_image": "Uploading a 2D image costs 1 coin",
		"360_degree_image": "Uploading a 360 degree image costs 2 coins",
		STARTING_OUT: "STARTING OUT",
		perCoin: "per coin",
		moreThan20Images: "When purchasing more than 20 images.",
		SCALING_UP: "SCALING UP",
		"10_20_images": "When purchasing 10 - 20 images.",
		PRO_DEAL: "PRO DEAL",
		upTo9Images: "When purchasing up to 9 images.",
		$: "$"
	},
	support: {
		title: "We are providing these services",
		description: "We help clients make their own virtual staging. You do not need to learn or master complicated softwares like 3D max, Corona, or Vray,... It takes you less than 30 minutes to complete a realistic virtual staging product.",
		normalTitle: "2D still photos",
		normalSubtitle: "Any image from any device.",
		panoTitle: "360 degree photos",
		panoSubtitle: "Photos was taken as ratio 2:1",
		tourTitle: "Panoramic Walk-Throughs",
		tourSubtitle: "Stitch together panoramas to create a 3D Walkthrough Virtual Tour FOR FREE",
		enhanceTitle: "AI Photo Editing",
		enhanceSubtitle: "Enhance your photos automatically by using AI"
	},
	embed: {
		title: "Embed our Virtual Staging service into your own website"
	},
	why: {
		title: "What is our advantages",
		"01_title": "Unbeatable price",
		"01_description": "We provide service with lowest price but best quality.",
		"02_title": "Quick Turnaround",
		"02_description": "Less than 30 minutes a photo.",
		"03_title": "Unlimited changes and top service",
		"03_description": "100% satisfaction with our unlimited change guarantee. Our customer service experts are available 24/7 on email.",
		"04_title": "And more great things",
		"04_description": "Receive 01 free offer on sign up and you will receive excellent quality."
	},
	steps: {
		"1_title": "You upload your photos",
		"2_title": "Remove your furniture with AI",
		"2_description": "Our AI-powered remove furniture function offers effortless customization, eliminating furniture items for a clean and personalized virtual space.",
		"3_title": "Choose furniture and then drag and drop them to photos",
		"4_title": "Render your designs and then receive the beautiful photos",
		"4_description": "A realistic photo will be created after rendering, you can continue to edit by using our tools to make photos brighter and increase contrast."
	},
	tourService: {
		supported: "Virtual Reality glasses are supported!",
		description: "After staging 360 degree photos, we support creating 3D Walk-through Virtual Tour",
		forFree: "FOR FREE"
	},
	services: {
		title: "Our services you may fall in love",
		"1_title": "Editing Photos/Image Enhancement",
		"1_subtitle": "$1 / output image",
		"2_title": "Changing color of walls, ceiling, type of floors",
		"2_subtitle": "$5 / image",
		"3_title": "Removing the existing furniture before staging",
		"3_subtitle": "$3 - 6 / image",
		"4_title": "If you don’t want to put virtual furniture to photos by yourself",
		"4_subtitle": "$10 / image",
		"5_title": "We will create 3d models and detailed furniture FROM your furniture image. And then you can use these 3D models for staging photos.",
		"5_subtitle": "From $20 - $50 / model",
		contactTitle: "And more Services. Let’s talk now",
		contactSubtitle: "Contact for more information"
	},
	ladingResult: {
		title: "Get A Realistic Result",
		quote: "Our app generates the realistic staged image within 20 minutes or less from the moment you upload your vacant image until you can see the final result.",
		BEFORE: "BEFORE",
		AFTER: "AFTER"
	},
	moneyBack: {
		title: "We guarantee 100% coins refund if you are not satisfied with the result.",
		description: "Try using our service with the first 1 free coin as soon as you sign up."
	}
};
var location = {
	empty: {
		title: "Turn your ideas into reality",
		subTitle: "Bring your ideas to life — we can't wait to see what you've got!",
		addANewDesign: "Add a new design"
	},
	createTour: {
		button: "Create a virtual tour",
		youCannotCreateTour: "You cannot create a virtual tour"
	},
	versionHistory: "Show version history",
	editImage: "Edit design information"
};
var progress = {
	title: "Progress",
	info: "See the latest updates regarding your images current state, including images ready to edit and renders.",
	clearNotifications: "Clear notifications",
	status: {
		processing: "Processing",
		ready: "Ready",
		rendering: "Rendering",
		refund: "Refunded",
		prefix: {
			finished: "Finished",
			failedWhile: "Failed While",
			canceledWhile: "Canceled While"
		}
	},
	empty: {
		title: "Nothing here",
		subTitle: "When you add a new image, it will display here in process status"
	},
	floorPlan: "(Floor Plan)"
};
var catalog = {
	items: "items",
	categories: "categories",
	rooms: "rooms"
};
var profile = {
	title: "My profile",
	imageReadyForEdit: "Send notification to email when image is ready for edit",
	renderResultIsReady: "Send notification to email when a render result is ready"
};
var apiKeys = {
	title: "API Keys",
	deleteConfirmation: "Are you sure you want to delete this API Key?"
};
var webhooks = {
	title: "Webhooks",
	deleteConfirmation: "Are you sure you want to delete this Webhook?"
};
var addDesign = {
	yourCoin: "Your coin",
	whatAreCoins: "What are coins?",
	spendCoin: "Spend Coins in order to upload your images to our service.",
	everyImageCosts: "Every image costs",
	earlyBeta: "For the early beta period, purchasing new coins is disabled.",
	insufficientBalance: "Unfortunately. you dont have enough tokens to upload an image. Please add more to continue!",
	turnYourIdeas: "Turn your ideas into reality",
	bringYourIdeas: "Bring your ideas to life — we can't wait to see what you've got!",
	support: "We support 360° images",
	dragYourImages: "Drag your 2D or 360 images here to start staging",
	browseFiles: "Browse Files",
	fileFormat: "File Format: JPEG, PNG",
	dropHere: "Drop here",
	invalidFileType: "Invalid file type",
	yourInformation: "Your information",
	enterLocation: "Enter location",
	enterOrSelect: "Enter or select from list",
	imageName: "Image name",
	egLivingRoom: "Eg: Living room",
	"2DImage": "2D Image",
	"360°Image": "360° Image",
	removeFurnitureWithAI: "Remove furniture with AI",
	removeFurnitureWithAIInfo: "Select unnecessary items to removed. Please note image's greater dimension will be scaled down to 2048px if it exceeds this limit.",
	autoVirtualStaging: "Auto virtual staging",
	autoVirtualStagingInfo: "Get your furniture placed automatically based on your preferences.",
	rooms: "Rooms",
	templates: "Templates",
	room: "Room",
	template: "Template",
	brush: "Brush",
	select: "Select",
	none: "None"
};
var imagesView = {
	historyTitle: "Version History",
	editingPhoto: "Editing photo",
	version: "Version",
	adjust: "Adjust",
	eraseWithEraserBrush: "Erase with Eraser Brush",
	at: "at",
	tourSteps: {
		selectVersion: {
			text: "Click this button to select a version of your realistic staging results."
		},
		startEdit: {
			title: "Adjust your photo",
			description: "Now, you can make your rooms more attractive  by click on button below",
			button: "Got It"
		},
		changeColor: {
			text: "You can change saturation, contrasts, brightness, and gamma of your realistic staging result here."
		},
		openEraser: {
			text: "Click here to start using the eraser."
		},
		eraserSize: {
			text: "You can change the size of the eraser here."
		},
		erase: {
			text: "Hold left mouse button and dragging over the photo to erase furniture items and their shadow."
		},
		switchToKeep: {
			text: "Click this button to switch to keep mode. With this mode, you can bring back furniture items that you erased."
		},
		keep: {
			text: "Hold left mouse button and dragging over the photo to keep furniture items and their shadow."
		},
		save: {
			text: "Click this button to save your realistic staging result."
		}
	},
	tourOptions: {
		text: "Ok",
		label: "Ok"
	},
	saturation: "saturation",
	contrast: "contrast",
	brightess: "brightess",
	hue: "hue",
	keepFurnitureLayer: "Keep only furniture layer",
	addCustomWatermark: "Add custom watermark",
	keep: "keep",
	remove: "remove"
};
var tourEditor = {
	exitPreviewButton: "Exit Preview mode",
	previewTour: "Preview Tour",
	saveDraft: "Save draft",
	vrButton: {
		enterVR: "Enter VR",
		exitVR: "Exit VR"
	},
	selectLinkedImage: {
		title: "Pick a linked room"
	}
};
var myTours = {
	title: "My tours",
	publishedVersions: "Published Versions",
	noTour: {
		title: "Welcome to my tour",
		description: "Make your location as a museum to showcase your home. You need to upload your 360° images to your location to create a virtual tour.",
		videoIntroduction: "Video Introduction"
	}
};
var paymentSuccessful = {
	title: "Payment successful",
	subTitle: "Congratulations! Your have completed your payment",
	button: "Back home"
};
var sidebar = {
	navItems: {
		locations: "Locations",
		tours: "My tours",
		progress: "Progress",
		catalog: "Catalog",
		"2d-instructions": "2D Photo Instructions",
		"360-instructions": "360° Photo + Tour Instructions",
		services: "Services",
		floorPlans: "Floor plans",
		virtualStaging: "Virtual Staging",
		generationHistory: "Generation History"
	},
	button: {
		addANewDesign: "Add a new design",
		"tryNow!": "Try now!",
		addMoreCoins: "Add more",
		inviteFriends: "Invite your friends"
	},
	info: {
		viewProfile: "View Profile",
		apiKeys: "API Keys",
		webhooks: "Webhooks",
		yourCoins: "Your coins",
		transactions: "Transaction history"
	},
	"new": "NEW",
	enhancement: "Enhance your photos automatically with",
	enterLocation: "Enter location",
	loadMore: "Load more",
	markAllAsRead: "Mark all as read"
};
var panoViewer = {
	title: "We encountered an error while setting up 3d editor.",
	error: "Error:"
};
var floorPlanLanding = {
	heading1: "Scan a home in",
	heading2: "5 minutes",
	heading3: "get a floor plan",
	heading4: "The easiest and fastest 2D & 3D floor plan app for iOS devices.",
	viewPricing: "View Pricing",
	roomMeasurement: "Room Measurement",
	customFloorPlanStyles: "Custom floor plan styles",
	personal1: "Agents & Photographers",
	usecase1: "Real Estate Listings",
	usecase1Subtitle: "Beautiful white labeled listing floor plans for your real estate marketing. Skip the pen and paper, and save hours of manual work!",
	why1Title: "Why use floor plans on a listing?",
	why1_1: "Home buyers consider floor plans the most desired feature on a home listing, just after the standard listing photos and property data (NAR research)",
	why1_2: "Get accurate property measurements automatically for all rooms in 5 minutes.",
	why1_3: "Stand out from the competition by providing a free marketable floor plan on-site to your client.",
	why1_4: "Reduce time on the market by up to 60% by adding a floor plan to your listing.",
	why1_5: "Increase click-throughs from buyers by 80% by including a floor plan in a real estate listing.",
	personal2: "APPRAISERS, AMCS AND LENDERS",
	usecase2: "Real Estate Appraisals",
	usecase2Subtitle: "Professional appraisal-ready GLA reports. Skip the pen and paper, and save hours of manual work!",
	why2Title: "Why scan with Betates instead of sketching on-site?",
	why2_1: "Create the floor plan with interior walls automatically without special hardware.",
	why2_2: "Scanning the property requires only minutes of work on-site and requires no training.",
	hiwTitle: "How it works?",
	hiw1Title: "1. Scan",
	hiw1Description: "Scan the property with Betates mobile app. It takes approximately 5 to 10 minutes.",
	hiw2Title: "2. Upload",
	hiw2Description: "Upload the scanned image to our platform.",
	hiw3Title: "3. Receive",
	hiw3Description: "Receive the floor plan within 12-16 hours.",
	features: "Features",
	featuresSubtitle1: "From your 5 minutes scan, you can get plenty of products to promote your properties and embellish your listings!",
	featuresSubtitle2: "From technical 2D floor plans, to 3D items for marketing, Betates has it all!",
	feature1: "2D Floor Plan",
	feature1_1: "Standard 2D floor plan",
	feature1_2: "Standard 2D floor plan with site plan",
	feature1_3: "Colorful 2D floor plan",
	feature1_4: "Colorful 2D floor plan with site plan",
	feature2: "3D Floor Plan",
	feature2_1: "Fixed Furniture",
	feature2_2: "Stylish and Simple Design",
	feature2_3: "Total sq. ft",
	feature2_4: "Your Branding",
	feature2_5: "6h or 24h Turnaround",
	feature3: "CAD Files",
	feature3_1: "From 2D or 3D floor plan",
	feature3_2: "Outputs: 2D DWG, 3D DWG, DAE, FBX and OBJ files",
	feature4: "2D Still and Panoramic Interior Rendering",
	feature4_1: "Displays the placement of furniture, windows, doors, wall designs, or decor",
	feature4_2: "Textures like wood, tile, fabric, etc., are symbolically represented",
	feature4_3: "Your Branding",
	feature4_4: "15-30 minutes turnaround",
	feature5: "VR Tour",
	feature5_1: "Allow users to look around in all directions (up, down, left, right)",
	feature5_2: "Users move through the space by clicking or tapping on hotspots—interactive markers that link one location to another",
	feature5_3: "Creates the feeling of walking from room to room",
	feature5_4: "Device Compatibility",
	feature6: "Interactive Floor Plan",
	feature6_1: "Easy-to-use menus or maps for room selection",
	feature6_2: "inimap or floor plan overlay to show current location",
	feature6_3: "Zoom controls, language settings, fullscreen toggle",
	feature6_4: "Clickable or Tappable Hotspots",
	feature6_5: "Users can click on rooms, icons, or furniture to view",
	pricing: "Pricing",
	pricingSubtitle: "Make your selections and preview your order",
	"2dFloorPlan": "2D Floor Plan",
	fixedFurniture: "Fixed Furniture",
	alwaysIncluded: "Always included",
	includedWith3DProduct: "Included with 3D product",
	"8hTurnaround": "8h Turnaround",
	"3dFloorPlan": "3D Floor Plan",
	furniture: "Furniture",
	"3dVideoRender": "3D Video Render",
	"3dVideoRenderSubtitle": "We provide a walkthrough video showcasing the key areas of the property. The average duration of the video ranges from 1-3 minutes, and is based on the size of the property. Delivery in MP4 format without audio.",
	"3dMarketingBundle": "3D Marketing Bundle",
	withFurniture: "with Furniture",
	withColoursAndTextures: "with Colours and Textures",
	cadFiles: "CAD Files",
	cadFilesSubtitle1: "CAD package includes 2D and 3D CAD files (obj, fbx, collada, autoCAD).",
	cadFilesSubtitle2: "Supported formats are: Dwg, dae, obj, fbx",
	yourSelection: "Your Selection",
	total: "Total",
	"2dStillInteriorRendering": "2D Still Interior Rendering",
	panoramicInteriorRendering: "Panoramic Interior Rendering",
	vrTour: "VR Tour",
	vrTourDescription: "Our service helps you create immersive VR tours by seamlessly transforming your rendered 360 images into interactive, fully navigable virtual experiences. Perfect for real estate, events, and more!",
	interactiveFloorPlan: "Interactive Floor Plan",
	interactiveFloorPlanDescription: "Our Interactive Floor Plan lets you view the home from multiple viewpoints throughout the space. Click on different areas of the floor plan to see detailed images and perspectives, giving you a clear and immersive sense of the home's layout and design."
};
var modal = {
	purchaseExtraRender: {
		title: "Purchase Extra Render",
		description: "Render limit reached. Please purchase extra render to continue.",
		pay: "Pay"
	},
	addApiKey: {
		title: "Add API Key"
	},
	addWatermark: {
		title: "Add Watermark"
	},
	addWebhook: {
		title: "Add Webhook"
	},
	autoStagingSelectBundles: {
		title: "Select templates",
		preferences: "Preferences",
		curtains: "Curtains",
		tabletops: "Tabletops",
		plants: "Plants",
		tvBedroom: "TV in Bedroom",
		tvLivingRoom: "TV in Living Room",
		lampLights: "Lamp Lights",
		dontUse: "Don't use",
		use: "Use",
		decorative: "Decorative",
		none: "None",
		few: "Few",
		plenty: "Plenty",
		always: "Always",
		whenInBundle: "When in bundle",
		never: "Never",
		off: "Off",
		on: "On"
	},
	checkout: {
		title: "Checkout"
	},
	confirmSwitchingVersion: {
		title: "You haven't save your adjustment",
		content: "If you continue switching your version. All your adjustment with this version will be lost",
		switchVersion: "Switch version"
	},
	contactForService: {
		"1": "Editing photos / Image enhancement",
		"2": "Changing color of walls, ceiling, type of floors",
		"3": "Removing the existing furniture before staging",
		"4": "If you don’t want to put virtual furniture to photos by yourself",
		"5": "Other",
		title: "Contact us",
		label1: "I need help about",
		label2: "Contact me via email",
		label3: "Message",
		label3Placeholder: "Your message",
		submitServiceSuccess: "We received your message and will response you in 1 working day"
	},
	deleteLocation: {
		title: "Delete Location",
		content_1: "Are you sure you want to delete the location?",
		content_2: "This action is irreversible"
	},
	editImage: {
		title: "Edit Image",
		location: "Location",
		locationPlaceholder: "Enter or select from list",
		imageName: "Image name"
	},
	editLocation: {
		title: "Edit Location",
		name: "Name"
	},
	imageUpload: {
		title: "Image is sent for processing",
		content_1: "Once they are ready to be designed, we will let you know.",
		content_2: "The estimated processing time is 1-10 minutes.",
		uploadMore: "Upload more images"
	},
	inviteFriends: {
		title: "Invite your friends to join us!",
		description_1: "When you friend make the first payment in our app, each one of you will get",
		description_2: "one bonus coin.",
		description_3: "Send you friends this link"
	},
	panoImageIntro: {
		title: "We now support 360° images!",
		description: "Betates now supports 360 images (equirectangular images). Uploading a 360° image will cost",
		perImage: "per image."
	},
	topUp: {
		purchase: "Purchase",
		total: "Total",
		button: "Proceed to checkout"
	},
	tourPublishSuccessfully: {
		title: "Congratulations",
		description: "Your virtual tour was created successfully",
		seeThisTour: "See this tour",
		share: "Share this tour via",
		qrCode: "QR code to view the tour"
	},
	tourVersions: {
		title: "Published Versions",
		noItem: "No item"
	},
	versionHistory: {
		title: "Version History"
	},
	vrNotSupported: {
		title: "Oops!",
		description: "Please use a device which supports WebXR. Meta quest is recommended."
	},
	whatWeDo: {
		"1": "White Balacing",
		"2": "Image Sharpening",
		"3": "Vertical & Horizontal Straightening",
		"4": "Remove Minor Blemishes",
		"5": "Lens Distortion Removal",
		"6": "Brightness & Contrast Adjustment",
		"7": "Sky Replacement",
		"8": "Lawn Enhancement – Repair or Replace ",
		"9": "Ocean/River Water Enhancement",
		"10": "Remove Pool Cleaners from Water",
		"11": "Tone Adjustment",
		title: "What we do"
	},
	filesUploaded: {
		title: "Files are sent for processing",
		content_1: "Once they are ready to be designed, we will let you know.",
		content_2: "The estimated processing time is within 24 hours.",
		uploadMore: "Create more floor plans"
	},
	floorPlan2dStyles: {
		title: "Styles",
		createStyle: "Create new style",
		name: "Name",
		disclaimerText: "Disclaimer text",
		logo: "Logo",
		removeLogo: "Remove logo",
		create: "Create",
		edit: "Edit",
		cancel: "Cancel",
		chooseStyle: "Choose a style",
		applyStyle: "Apply style",
		save: "Save",
		marginLeft: "Margin left",
		marginBottom: "Margin bottom",
		width: "Width"
	},
	confirmPayExtraService: {
		title: "Confirmation",
		description: "Are you willing to pay for this extra service",
		pay: "Pay"
	},
	confirmPurchaseExtraCamera: {
		title: "Confirmation",
		description: "Are you willing to pay for this extra camera",
		pay: "Pay"
	}
};
var common = {
	auto: "Auto",
	or: "or",
	email: "Email",
	password: "Password",
	name: "Name",
	login: "Login",
	"continue": "Continue",
	cancel: "Cancel",
	close: "Close",
	add: "Add",
	sorry: "Sorry",
	next: "Next",
	back: "Back",
	finish: "Finish",
	reset: "Reset",
	go: "Go",
	publish: "Publish",
	edit: "Edit",
	save: "Save",
	change: "Change",
	view: "View",
	send: "Send",
	"delete": "Delete",
	upload: "Upload",
	uploading: "Uploading...",
	addMore: "Add more",
	readMore: "Read More",
	tryItNow: "Try it now",
	logout: "Logout",
	viewDetail: "View Detail",
	description: "Description",
	key: "Key",
	createdAt: "Created At",
	loading: "Loading",
	gotIt: "Got it",
	logOut: "Log out",
	URL: "URL",
	images: "images",
	renders: "renders",
	contactUs: "Contact Us",
	allRightsReserved: "All rights reserved",
	termsOfServices: "Terms of services",
	instructionsForUse: "Instructions for use",
	privacyPolicy: "Privacy policy",
	letsTalk: "Let's talk",
	acceptTermsOfServices: "I've read and accept the terms and conditions",
	copiedURL: "Copied URL to clipboard",
	minimumScreenWidth: {
		title: "Your screen is too small",
		subTitle: "Please use a wider screen to view this page.",
		button: "Go Back"
	},
	open: "Open",
	confirm: "Confirm"
};
var error = {
	logInWithGoogle: "Failed to log in with Google, please try again",
	somethingWentWrong: "Something went wrong",
	invalidURL: "Invalid URL",
	fileTooLarge: "File too large. Please select file which has size up to 20MB.",
	fileTooLarge200MB: "File too large. Please select file which has size up to 200MB.",
	webGLError: {
		title: "We encountered an error while setting up 3d editor.",
		descriptionPrefix: "Error:"
	},
	descriptionIsRequired: "Description is required."
};
var success = {
	updatedSuccessfully: "Updated successfully"
};
var betates = {
	name: "Betates",
	slogan: "Discover the way to brighten your sweet home.",
	description: "Betates is a modern online editor that enables you to virtually stage your property images.",
	coin_one: "coin",
	coin_other: "coins",
	$: "$",
	email: "support@auto-design.io"
};
var editor = {
	resetZoom: "Reset zoom",
	categories: "Categories",
	"3dEditor": "3D Editor",
	actionButton: {
		clearModels: "Clear models",
		undo: "Undo",
		showGallery: "Show gallery",
		fullScreen: "Full screen",
		environmentLight: "Environment light",
		roomScale: "Room scale",
		zoom: "Zoom",
		shortcuts: "Shortcuts",
		howToUse: "How to use",
		cameraSetup: "Camera setup",
		zoomCameraIn: "Zoom camera in",
		zoomCameraOut: "Zoom camera out",
		elevateUp: "Elevate up",
		elevateDown: "Elevate down"
	},
	configurator: {
		swap: "Swap",
		ungroup: "Ungroup",
		group: "Group",
		remove: "Remove",
		duplicate: "Duplicate",
		flip: "Flip",
		lapmLightingSettings: "Lamp lighting settings",
		color: "Color",
		intensity: "Intensity",
		advancedSettings: "Advanced settings",
		horizontal: "Horizontal",
		vertical: "Vertical",
		depth: "Depth",
		scale: "Scale",
		rotation: "Rotation",
		horizontalScale: "Horizontal Scale",
		verticalScale: "Vertical Scale",
		depthScale: "Depth Scale"
	},
	renderButton: {
		settingsTitle: "Render Settings",
		settingsDescription: "Rendering time using the default settings will range from 10 to 20 minutes. Max resolution is 12 megapixels.",
		resolution: "Resolution",
		originalSize: "Original size",
		manualSetting: "Manual Setting",
		outputFormat: "Output format",
		jpeg: "JPEG",
		png: "PNG",
		imageWidth: "Image Width (px)",
		imageHeight: "Image Height (px)",
		render: "Render",
		submitting: "Submitting...",
		render360: "Render 360° image",
		renderStill: "Render still image"
	},
	itemList: {
		description: "Click or drag a furniture to the image."
	},
	initialScreen: {
		roomBundle: "Room bundle",
		roomBundleDescription: "Collections of furniture that work well together to create cohesive designs",
		byCategory: "By category",
		byCategoryDescription: "Choose furniture by category of available items",
		sameLocation: "Same location",
		sameLocationDescription: "Use the furniture you have already placed in other images in the same location to create consistency",
		personalCollections: "Personal collections",
		personalCollectionsDescription: "Create, Edit and use custom collections of your favourite furniture"
	},
	personalCollections: {
		title: "Personal collections",
		empty: "No collection",
		create: "Create Collection",
		customModelDescription: "We will create 3d models and detailed furniture FROM your furniture image. And then you can use these 3D models for staging photos. Pls contact with us:"
	},
	roomBundle: {
		title: "Room Bundle"
	},
	sameLocation: {
		title: "Same location"
	},
	sameLocationImage: {
		explanation: "Reuse furniture from previous renders",
		copyAllItems: "Copy all items to the current design"
	},
	swap: {
		title: "Swap furniture",
		swap: "Swap",
		cancel: "Cancel",
		category: "Category"
	},
	modal: {
		addItemToPersonalCollections: {
			title: "Save furniture to personal collections",
			empty: "No collection",
			createNewCollection: "Create new collection",
			save: "Save"
		},
		chooseRenderToCopy: {
			title: "Select a previous render to reuse its furniture",
			load: "Load Furniture"
		},
		renderSent: {
			title: "Image sent for rendering!",
			content: "Once the final result is ready, we will let you know via email and in progress page.",
			close: "Keep Editing"
		},
		shortcuts: {
			title: "Editor shortcuts",
			action: "Action",
			shortcut: "Shortcut",
			action1: "Undo last action",
			prefixShortcut1: "Press ",
			shortcut1: "Ctrl + Z",
			action2: "Move furniture",
			prefixShortcut2: "Press the ",
			shortcut2: "Arrow keys",
			suffixShortcut2: " (◀️▶️ 🔼🔽)",
			action3: "Delete furniture",
			prefixShortcut3: "Press ",
			shortcut3: "Delete or Backspace",
			action4: "Scale furniture",
			shortcut4: "Press ➕ or ➖ (resize up or down) ",
			action5: "Rotate furniture",
			prefixShortcut5: "Hold ",
			shortcut5: "Ctrl + Drag",
			suffixShortcut5: " item left/right",
			action6: "Multi-select furniture",
			prefixShortcut6: "Hold ",
			shortcut6: "Shift + Click",
			suffixShortcut6: " on multiple items",
			action7: "Viewer Zoom",
			prefixShortcut7: "Roll ",
			shortcut7: "mouse wheel",
			suffixShortcut7: " or spread/pinch with two fingers on your trackpad"
		}
	},
	tourSteps: {
		clickOrDrag: "Click or drag a furniture to the image.",
		clickAdd: "Click to add the furniture to the image.",
		move: "Move a piece of furniture by dragging it.",
		changeOrientation: "Here you can change the orientation, position and scale of the furniture in tiny amount for precise positioning.",
		remove: "By clicking, the furniture will be removed from the image.",
		render: "Once you finished your design, press Render to get a realistic staging result. You can try render multiple items, so make sure to try different designs!"
	},
	cameraConfigurator: {
		camera: "Camera",
		view: "View from this camera",
		remove: "Remove camera"
	},
	cameraList: {
		list: "Camera list",
		editName: "Edit name",
		remove: "Remove",
		save: "Save",
		addCamera: "Add camera",
		swtich3DOverviewCamera: "Switch to 3D overview camera",
		swtich2DOverviewCamera: "Switch to 2D overview camera"
	}
};
var apiError = {
	DEFAULT: "Error",
	INTERNAL_SERVER_ERROR: "Internal Server Error",
	UNAUTHORIZED: "Unauthorized",
	FORBIDDEN: "You don't have access to this resource",
	BAD_REQUEST: "Bad request",
	NOT_FOUND: "Not found",
	INSUFFICIENT_BALANCE: "Insufficient balance",
	INVALID_REFER_TOKEN: "Invalid refer token",
	INVALID_RECAPTCHA_TOKEN: "Invalid recaptcha token",
	INVALID_PASSWORD: "Password must be at least 8 characters with mixture of uppercase, lowercase, numeric and inclusion of at least one special character.",
	INVALID_ITEM_ID: "Invalid item ID.",
	WRONG_PASSWORD: "Wrong password",
	GOOGLE_LOGIN_REQUIRED: "Please login with Google!",
	EMAIL_ALREADY_EXISTS: "Email is already taken.",
	NO_CONSUME_TRANSACTION_FOUND: "No consume transaction found.",
	CATEGORY_NAME_ALREADY_EXISTS: "Category with this name already exists.",
	ITEM_NAME_ALREADY_EXISTS: "Item with this name already exists.",
	STYLE_NAME_ALREADY_EXISTS: "Style with this name already exists.",
	ROOM_NAME_ALREADY_EXISTS: "Room with this name already exists.",
	ROOM_STYLE_NAME_ALREADY_EXISTS: "Room/Style with this name already exists.",
	LOCATION_NAME_ALREADY_EXISTS: "Location with this name already exists.",
	PERSONAL_COLLECTION_TITLE_ALREADY_EXISTS: "Personal collection with this title already exists.",
	TOUR_NAME_ALREADY_EXISTS: "A tour with the same name exists.",
	NOT_ALLOWED: "Not allowed!",
	UNSUPPORTED_INPUTS: "Unsupported inputs",
	IMAGE_CLAIM_ERROR: "Cannot claim this image",
	RENDER_LIMIT_REACHED: "Render limit reached. Please contact support for more details.",
	COLLECTION_EDIT_FORBIDDEN: "Can't edit this collection.",
	COLLECTION_DELETE_FORBIDDEN: "Can't delete this collection.",
	ITEM_ADDITION_FORBIDDEN: "Can't add item to this collection.",
	INSUFFICIENT_RENDERED_IMAGES: "This function requires rendered 360° images to create a tour. Please add more to continue!",
	PAYMENT_UNSUCCESSFUL: "Payment unsuccessful. Please contact support for assistance.",
	USER_NOT_FOUND: "User not found",
	ADMIN_NOT_FOUND: "Admin not found",
	TENANT_NOT_FOUND: "Tenant not found",
	FILE_NOT_FOUND: "File not found",
	TOUR_VERSION_NOT_FOUND: "Tour version not found",
	CONFIG_NOT_FOUND: "Config not found",
	DESIGNER_NOT_FOUND: "Designer not found",
	EXPORT_NOT_FOUND: "Export not found",
	IMAGE_NOT_FOUND: "Image not found",
	IMAGE_NOT_FOUND_OR_INCORRECT_STATUS: "Image not found or not in the correct status",
	CATEGORY_NOT_FOUND: "Category not found",
	ITEM_NOT_FOUND: "Item not found",
	ROOM_NOT_FOUND: "Room not found",
	PARENT_ROOM_NOT_FOUND: "Parent room not found",
	PROGRESS_NOT_FOUND: "Progress not found",
	RENDERER_NOT_FOUND: "Renderer not found",
	API_KEY_NOT_FOUND: "API key not found",
	LOCATION_NOT_FOUND: "Location not found",
	PERSONAL_COLLECTION_NOT_FOUND: "Personal collection not found",
	TOUR_NOT_FOUND: "Tour not found",
	VERSION_NOT_FOUND: "Version not found",
	TRANSACTION_NOT_FOUND: "Transaction not found",
	WATERMARK_NOT_FOUND: "Watermark not found",
	WEBHOOK_NOT_FOUND: "Webhook not found",
	FILE_ACCESS_DENIED: "You don't have access to this file!"
};
var createFloorPlan = {
	totalPrice: "Total Price:",
	notEnoughCoins: "You don't have enough coins.",
	addMoreCoins: "Add more coins",
	extraCost: " Note: If any floor is larger than 200m² then we will request you to pay extra cost after we evaluating the inputs.",
	createFloorPlanFromMatterPort: "Create floor plan from Matterport",
	complete2DFloorPlan812h: "Complete 2D floor plan in 8-12 hours",
	complete3DFloorPlan1618h: "Complete 3D floor plan in 16-18 hours",
	filesSelection: {
		title: "Prepare your files",
		"continue": "Continue",
		addMatterpotUrl: "Add a Matterpot URL...",
		drag: "Drag your images here to start staging or",
		browse: "Browse",
		dropHere: "Drop here"
	},
	information: {
		title: "Complete the information",
		enterLocation: "Enter location",
		enterOrSelect: "Enter or select from list",
		name: "Name",
		egName: "Eg: 350 W International Airport Rd #101",
		howManyFloors: "How many floors do you need",
		allowInsert2d: "(2D) Allow our installation of furniture",
		allowInsert3d: "(3D) Allow our installation of cameras and furniture",
		extraFee: "Extra fee will be required",
		upload: "Upload",
		notes: "Notes"
	},
	packages: {
		choosePackages: "Choose your packages",
		changePreference: "Change your preference",
		"continue": "Continue",
		or: "Or",
		select: "Select",
		notice: "Notice",
		notice1: "You should purchase from 20 coins in a turn to get the best price (1 coin = 5 USD).",
		notice2: "This product does not support refund.",
		notice3: "You will have 3 days to review the order after we submit the result."
	}
};
var floorplanOverview = {
	requestChanges: "Request changes",
	changes: "What do you want to change?",
	submit: "Submit",
	cost: "Cost",
	free: "Free",
	changeEmpty: "Changes content must not be empty.",
	changeMaxLength: "Changes content must be no more than 1000 characters.",
	submittedChanges: "Submitted your changes successfully.",
	inputFiles: "Input Files",
	openEditor: "Open 3D Editor",
	open2DEditor: "Open 2D Editor",
	tabs: {
		"2d": "2D",
		"3d": "3D",
		inputs: "INPUTS",
		changeRequests: "CHANGE REQUESTS",
		extraServices: "EXTRA SERVICES"
	},
	weAreProcessing: "We're processing your change request. Please wait.",
	lastRequests: "Your last requests",
	"3dVideoTour": "3D Video Tour",
	"3dVideoTourDescription": " Showcase your property like never before with a captivating 3D video tour, offering a detailed and immersive overview of its layout and features from every angle. Perfect for virtual walkthroughs, presentations, or showcasing to clients.",
	result: "Result: ",
	request: "Request",
	requested: "Requested",
	cadFile: "CAD File",
	cadFileDescription: "Our service offers a professional CAD file conversion for your existing floor plan, providing you with an editable, precise digital version. Ideal for further design work, renovations, or easy integration into architectural projects.",
	extraCostDescription1: "We have reviewed your input files and found that your floor plan will require additional costs.",
	extraCostDescription2: "To ensure we can proceed with the best possible outcome for your project, we encourage you to approve this extra cost. This will help us deliver the highest quality results tailored to your needs.",
	requestRefund: "Request refund",
	pay: "Pay",
	reason: "Reason:",
	processing: "We are currently processing your floor plan and will get back to you within 12 to 24 hours.",
	floorPlan3D: "3D Floor Plan",
	floorPlan3DDescription: "Transform your space with our stunning 3D floor plans! Get a detailed, interactive visual representation of your property that makes design and layout decisions easier than ever.",
	floorPlan2D: "2D Floor Plan",
	floorPlan2DDescription: "Transform your space with our professional 2D floor plan services! We provide detailed, accurate layouts to help you visualize your design and optimize your space efficiently.",
	requestFilesTitle: "To enhance the accuracy of the floor plan, we kindly request that you provide additional files due to some processing challenges with the current ones. More details:",
	vrTour: "VR Tour",
	vrTourDescription: "Our service helps you create immersive VR tours by seamlessly transforming your rendered 360 images into interactive, fully navigable virtual experiences. Perfect for real estate, events, and more!",
	floorPlanInputFiles: {
		title: "Input files",
		saveSuccess: "Saved your files successfully.",
		save: "Save"
	},
	seeDesignerNotes: "Click to see designer's notes"
};
var editor2d = {
	"2dEditor": "2D Editor",
	save: "Save",
	boundary: "Boundary",
	name: "Name",
	showDim: "Show dimensions",
	manualDim: "Enter dimensions manually",
	width: "Width (m)",
	height: "Height (m)",
	length: "Length (m)",
	measurementLine: "Measurement Line",
	fontSize: "Font size"
};
var floorPlanStatus = {
	uploading: "Uploading",
	needs_information: "Needs information",
	created: "Processing",
	converting: "Converting",
	ready: "Ready",
	refunded: "Refunded",
	failed: "Failed",
	extra_cost_approval: "Extra Cost Requested",
	request_refund: "Refund requested",
	change_requested: "Change requested",
	not_sent: "Not sent"
};
var statusBadge = {
	processing: "Processing",
	needs_information: "Needs information",
	ready: "Ready",
	failed: "Failed",
	refunded: "Refunded",
	extra_cost_approval: "Extra Cost Requested",
	request_refund: "Refund requested",
	request_files: "Extra files requested",
	change_requested: "Change requested",
	not_sent: "Not sent",
	converting: "Converting"
};
var floorPlanPackageShort = {
	standard_2d: "Standard 2D",
	standard_2d_with_site_plan: "Standard 2D + Site plan",
	color_2d: "Colorful 2D",
	color_2d_with_site_plan: "Colorful 2D + Site plan",
	standard_3d: "3D",
	insert_furniture_2d: "Pre-inserted furniture (2D)",
	insert_cameras_and_furniture_3d: "Pre-inserted cameras & furniture (3D)",
	video: "Video",
	cad: "CAD",
	tour: "VR Tour",
	matterport: "Matterport",
	"2d_8_12_h": "Complete 2D in 8-12h",
	"3d_16_18_h": "Complete 3D in 16-18h",
	room_plan: "AI Room Plan"
};
var floorPlans = {
	title: "Floor Plans",
	status: "STATUS",
	name: "NAME",
	floors: "FLOORS",
	packages: "PACKAGES",
	createdAt: "CREATED AT",
	edit: "Edit",
	quickEdit: "Quick Edit",
	download: "Download",
	downloadAll: "Download All",
	save: "Save",
	disclaimerAndLogo: "Disclaimer & Logo",
	addFloorPlan: "Add floor plan",
	loadMore: "Load more"
};
var services = {
	tryItNow: "Try it now",
	aiVirtualStaging: {
		title: "AI Virtual Staging",
		subtitle: "Instant and easy home staging for Real Estate Agents, Design Professionals, Retailers & more"
	},
	virutalStaging: {
		title: "Virtual staging",
		description: "Design your dream home with 2D & 360° virtual staging and immersive 3D tours"
	},
	floorPlan: {
		title: "2D & 3D floor plan and interior rendering",
		description: "Upload via Matterport, C4D, or photos —we’ll help design and render your space"
	},
	photoEditing: {
		title: "Photo Editing",
		description: "Make every detail of your home shine with brilliance and style"
	},
	otherServices: {
		title: "We help you do all services by manually",
		description: "Are you ready? Discover more on",
		visitBetates: "Visit Betates"
	}
};
var transactionHistory = {
	title: "Transaction history",
	transactionName: {
		top_up: "Top up",
		consume_to_upload_image: "Consume coins for uploading",
		refund: "You are refuned coins",
		refer_bonus: "You received coins for referring new user",
		consume_to_request_changes: "Consume coins for request change",
		admin_charge: "Admin charges coins",
		consume_to_purchase_packages: "Consume coins for purchasing package",
		consume_to_purchase_floor_plan_extra_camera: "Consume coins for extra camera",
		ADMIN_CHARGE: "Admin change your coins balance"
	},
	floorPlan: "Floor plan",
	image: "Image"
};
var notification = {
	floor_plan_ready: "Your floor plan \"{{floorPlanName}}\" is ready.",
	floor_plan_needs_extra_files: "Your floor plan \"{{floorPlanName}}\" needs extra files.",
	floor_plan_needs_extra_cost: "You need to pay extra cost for your floor plan \"{{floorPlanName}}\".",
	floor_plan_video_ready: "3D Video Tour for your floor plan \"{{floorPlanName}}\" is ready.",
	floor_plan_cad_ready: "CAD file for your floor plan \"{{floorPlanName}}\" is ready.",
	floor_plan_refunded: "You have been refuned coins for your floor plan \"{{floorPlanName}}.",
	render_done: "Your render is done.",
	image_refunded: "You have been refuned coins for your image \"{{imageName}}.",
	floor_plan_failed: "Sorry, we can proceed your floor plan \"{{floorPlanName}}\". Reason: {{error}}",
	image_failed: "Sorry, we can proceed your image \"{{imageName}}\". Reason: {{error}}",
	image_ready: "Your image \"{{imageName}}\" is ready.",
	floor_plan_needs_information: "Your floor plan \"{{floorPlanName}}\" needs more information.",
	gen_ai_image_completed: "Your AI virtual staging is ready.",
	gen_ai_image_failed: "Sorry, we can proceed your AI virtual staging."
};
var createGenAIImage = {
	title: "AI Virtual Staging",
	dragYourRoomHere: "Drag your room here to start",
	orTryOurTemplates: "or try our templates",
	tellUsAboutYourIdea: "Tell us a bit about your idea",
	thisIsAPhotoOfARoom: "This is a photo of",
	pickARoom: "Pick a room",
	"in": "in",
	pickAStyle: "Pick a style",
	iWantTo: "I want to",
	remove: "remove",
	keep: "keep",
	exisitngFurniture: "existing furniture",
	generate: "Generate",
	generating: "Generating...",
	or: "or",
	browse: "Browse",
	freeGenerationsLeft: "{{count}} generations left",
	youDonHaveEnoughCoins: "You dont have enough coins to generate this image",
	feelFreeToAddMore: "Feel free to add more coins to continue your experience",
	forGenerations: "for {{count}} generations"
};
var genAIRoomTypes = {
	"living room": "Living room",
	bedroom: "Bedroom",
	"dining room": "Dining room",
	home_office: "Home office",
	kitchen: "Kitchen",
	bathroom: "Bathroom",
	outdoor: "Outdoor",
	"children's bedroom": "Children's bedroom"
};
var genAIStyles = {
	modern: "Modern",
	scandinavian: "Scandinavian",
	industrial: "Industrial",
	mid_century: "Mid-century",
	light_luxury: "Light luxury",
	modern_farmhouse: "Modern farmhouse",
	coastal: "Coastal",
	standard: "Standard"
};
var genAIImage = {
	title: "AI Virtual Staging",
	variants: "Variant {{index}}",
	processing: "We're working on your AI virtual staging. This may take a few minutes, please wait...",
	failed: "We're sorry that we couldn't generate your AI virtual staging. Your coins have been refunded to your account.",
	download: "Download",
	boostResolution: "Boost resolution",
	regenerate: "Re-generate",
	share: "Share",
	shareTitle: "Share this image",
	shareDescription: "Share this amazing AI-generated image with your friends and followers!",
	referAFriend: "Refer a friend",
	diyService: "DIY Service",
	hireUs: "Hire us"
};
var genAIImageHistory = {
	title: "Generation History",
	errorMessage: "Failed to load image history. Please try again.",
	emptyMessage: "No images found in your generation history.",
	loadMore: "Load More",
	imagesText: "images",
	today: "Today",
	yesterday: "Yesterday",
	variants: "Variants"
};
var genAIImageFeedback = {
	title: "Are you happy with this result?",
	buyMoreCoinsText: "If you'd like to generate more AI-rendered images",
	buyMoreCoinsButton: "Buy more coin",
	ourServicesText: "To explore more detailed and customizable edits",
	ourServicesButton: "Our services"
};
var translation = {
	mobile: mobile,
	auth: auth,
	homepage: homepage,
	location: location,
	progress: progress,
	catalog: catalog,
	profile: profile,
	apiKeys: apiKeys,
	webhooks: webhooks,
	addDesign: addDesign,
	imagesView: imagesView,
	tourEditor: tourEditor,
	myTours: myTours,
	paymentSuccessful: paymentSuccessful,
	sidebar: sidebar,
	panoViewer: panoViewer,
	floorPlanLanding: floorPlanLanding,
	modal: modal,
	common: common,
	error: error,
	success: success,
	betates: betates,
	editor: editor,
	apiError: apiError,
	createFloorPlan: createFloorPlan,
	floorplanOverview: floorplanOverview,
	editor2d: editor2d,
	floorPlanStatus: floorPlanStatus,
	statusBadge: statusBadge,
	floorPlanPackageShort: floorPlanPackageShort,
	floorPlans: floorPlans,
	services: services,
	transactionHistory: transactionHistory,
	notification: notification,
	createGenAIImage: createGenAIImage,
	genAIRoomTypes: genAIRoomTypes,
	genAIStyles: genAIStyles,
	genAIImage: genAIImage,
	genAIImageHistory: genAIImageHistory,
	genAIImageFeedback: genAIImageFeedback
};

var dataURItoBlob = function(dataURL) {
    if (!window || window.window !== window) {
        throw new Error('This module is only available in browser');
    }
    var Blob = window.Blob || window.MozBlob || window.WebKitBlob;
    if (!Blob) {
        throw new Error('Blob was not supported');
    }
    var dataURLPattern = /^data:((.*?)(;charset=.*?)?)(;base64)?,/;
    // parse the dataURL components as per RFC 2397
    var matches = dataURL.match(dataURLPattern);
    if (!matches) {
        throw new Error('invalid dataURI');
    }
    // default to text/plain;charset=utf-8
    var mediaType = matches[2] ? matches[1] : "text/plain".concat(matches[3] || ';charset=utf-8');
    var isBase64 = !!matches[4];
    var dataString = dataURL.slice(matches[0].length);
    var byteString = isBase64 ? atob(dataString) : decodeURIComponent(dataString);
    var array = [];
    for(var i = 0; i < byteString.length; i++){
        array.push(byteString.charCodeAt(i));
    }
    return new Blob([
        new Uint8Array(array)
    ], {
        type: mediaType
    });
};
var imgToBlob = function(img) {
    var canvas = document.createElement('canvas');
    canvas.width = img.width;
    canvas.height = img.height;
    var ctx = canvas.getContext('2d');
    ctx.drawImage(img, 0, 0);
    return new Promise(function(resolve, reject) {
        try {
            canvas.toBlob(function(blob) {
                resolve(blob);
            });
        } catch (e) {
            reject(e);
        }
    });
};

export { AUTO_STAGING_DEFAULT_PREFERENCES, AUTO_STAGING_PREFERENCES_SPECS, Auth, CheckBox, FloorPlanFileSource, FloorPlanFileSourceName, FloorPlanLogName, FloorPlanPackage, FloorPlanPackageName, FloorPlanStatus, Icon, ImageType, ImageTypeNameMap, Key, KeyCharacter, LightColor, LightItensity, Mode, PerFloorPackages, Request, Storage, Toast, ToastContextProvider, translation as baseTranslationEn, dataURItoBlob, getLocaleDateString, imgToBlob, useHandleClickOutside, useToastContext, withMinimumScreenWidth };
//# sourceMappingURL=index.js.map
